/* =========================================================
   Star for Michelle Francisco Beauty
   Login-aware, country-aware, product-aware, supplier-safe
========================================================= */

(function () {
  const DOMENG_TEXT = "STAR";
  const DOMENG_HTML = "STAR";
  const DOMENG_MEMORY_EMAIL_KEY = "mfb_domeng_memory_email";

  const DOMENG_SESSION = {
  messages: [],
  lastMood: null,
  lastCountry: null,
  lastCategory: null,
  lastOccasion: null,
  lastBudget: null,
  lastAudience: null,
  lastIntent: null
};
  const DOMENG_PERSISTENT = {
  loaded: false,
  messages: [],
  memory: {}
};
  const DOMENG_CONFIG = {
    brand: "Michelle Francisco Beauty",
    assistantName: DOMENG_TEXT,

    /*
      This endpoint will work after the secure Shopify App Proxy backend is installed.
      Until then, Star still works with smart front-end fallback answers.
    */
    endpoint: "/apps/domeng",

    links: {
      newArrivals: "/collections/all?sort_by=created-descending",
      dresses: "/collections/dresses",
      shopAll: "/collections/all",
      giftCard: "/products/michelle-francisco-beauty-gift-card",
      trackOrder: "/account",
            ambassador: "https://jeepney.io/mfb-affiliate",
      contact: "/pages/contact",
      faq: "/pages/faqs",
      login: "/account/login",
      register: "/account/register"
    },

quickActions: [
  "Style Quiz",
  "Date Night Outfit",
  "Complete the Look",
  "What’s in My Bag?",
  "Check Shipping to My Country",
  "Become an Ambassador"
]
  };

  const M_COLLECTION_COUNTRIES = [
    "Albania",
    "Australia",
    "Austria",
    "Belgium",
    "Brazil",
    "Bulgaria",
    "Canada",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Ireland",
    "Israel",
    "Italy",
    "Japan",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Mexico",
    "Morocco",
    "Netherlands",
    "New Zealand",
    "Nigeria",
    "Pakistan",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Saudi Arabia",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden",
    "United Arab Emirates",
    "United Kingdom",
    "United States"
  ];

  const COUNTRY_ALIASES = {
    "usa": "United States",
    "us": "United States",
    "u.s.": "United States",
    "u.s.a.": "United States",
    "america": "United States",
    "united states of america": "United States",
    "uk": "United Kingdom",
    "u.k.": "United Kingdom",
    "england": "United Kingdom",
    "britain": "United Kingdom",
    "great britain": "United Kingdom",
    "uae": "United Arab Emirates",
    "u.a.e.": "United Arab Emirates",
    "dubai": "United Arab Emirates",
    "abu dhabi": "United Arab Emirates",
    "ksa": "Saudi Arabia",
    "saudi": "Saudi Arabia",
    "czechia": "Czech Republic",
    "holland": "Netherlands",
    "ph": "Philippines",
    "philippines": "Philippines"
  };

  const DOMENG_MOOD_PROFILES = {
  "soft_feminine": {
    labels: [
      "soft feminine",
      "feminine",
      "girly",
      "romantic",
      "soft",
      "pretty",
      "delicate",
      "graceful",
      "sweet"
    ],
    searchTerms: [
      "floral dress",
      "pink dress",
      "lavender dress",
      "lace",
      "midi dress",
      "mini dress",
      "soft top",
      "skirt",
      "dress"
    ],
    answer:
      "Soft Feminine Mood is about delicate color, graceful lines, florals, lace, and romantic silhouettes. I will look for pieces that feel pretty, gentle, elegant, and feminine."
  },

  "power_woman": {
    labels: [
      "power woman",
      "power",
      "boss",
      "boss lady",
      "ceo",
      "confident",
      "strong",
      "commanding",
      "boardroom"
    ],
    searchTerms: [
      "black",
      "blazer",
      "structured",
      "dress",
      "midi dress",
      "top",
      "bag",
      "gold",
      "work"
    ],
    answer:
      "Power Woman Look is about confidence, clean structure, darker tones, elevated basics, and pieces that make the shopper feel composed, sharp, and in control."
  },

  "date_night": {
    labels: [
      "date night",
      "dinner date",
      "romantic night",
      "night out",
      "sexy",
      "alluring",
      "evening",
      "cocktail"
    ],
    searchTerms: [
      "black dress",
      "mini dress",
      "midi dress",
      "lace",
      "bodycon",
      "evening",
      "top",
      "bag",
      "jewelry"
    ],
    answer:
      "Date Night Outfit is about confidence, softness, curve-flattering shapes, beautiful neckline details, and a look that feels memorable without being overdone."
  },

  "brunch": {
    labels: [
      "brunch",
      "day out",
      "day date",
      "sunday",
      "garden",
      "ladies lunch",
      "casual elegant"
    ],
    searchTerms: [
      "floral dress",
      "midi dress",
      "mini dress",
      "white",
      "pink",
      "lavender",
      "top",
      "skirt",
      "bag"
    ],
    answer:
      "Brunch Outfit is about light, fresh, relaxed elegance. I will look for pieces that feel daytime-ready, pretty in photos, and effortless."
  },

  "vacation": {
    labels: [
      "vacation",
      "resort",
      "beach",
      "summer",
      "travel",
      "holiday",
      "getaway",
      "cruise"
    ],
    searchTerms: [
      "summer dress",
      "mini dress",
      "maxi dress",
      "floral",
      "tote",
      "bag",
      "white",
      "blue",
      "casual"
    ],
    answer:
      "Vacation Mood is about ease, movement, color, comfort, and pieces that look beautiful in travel photos while still feeling relaxed."
  },

  "workwear": {
    labels: [
      "workwear",
      "work",
      "office",
      "meeting",
      "professional",
      "business",
      "polished",
      "smart casual"
    ],
    searchTerms: [
      "black",
      "white",
      "top",
      "blouse",
      "midi dress",
      "structured",
      "bag",
      "neutral",
      "classic"
    ],
    answer:
      "Elegant Workwear is about polish, simplicity, comfort, and quiet authority. I will look for pieces that can move from office to after-hours."
  },

  "minimalist_chic": {
    labels: [
      "minimalist",
      "minimal",
      "clean girl",
      "clean",
      "simple",
      "quiet luxury",
      "neutral",
      "timeless"
    ],
    searchTerms: [
      "white",
      "black",
      "neutral",
      "classic",
      "seamless",
      "top",
      "dress",
      "bag",
      "basic"
    ],
    answer:
      "Minimalist Chic is about clean lines, neutral colors, simplicity, and timeless pieces that look expensive without trying too hard."
  },

  "luxe_casual": {
    labels: [
      "luxe casual",
      "casual luxe",
      "everyday luxury",
      "effortless",
      "weekend",
      "comfortable",
      "casual"
    ],
    searchTerms: [
      "casual",
      "top",
      "bra",
      "loungewear",
      "dress",
      "bag",
      "seamless",
      "basic",
      "soft"
    ],
    answer:
      "Luxe Casual is about comfort elevated with polish. I will look for pieces that are easy to wear but still feel curated and stylish."
  },

  "gift": {
    labels: [
      "gift",
      "birthday gift",
      "present",
      "surprise",
      "for her",
      "wife",
      "girlfriend",
      "mom"
    ],
    searchTerms: [
      "gift",
      "gift card",
      "bag",
      "jewelry",
      "beauty",
      "dress",
      "accessories"
    ],
    answer:
      "Gift Mood is about safe, elegant, easy-to-love pieces. I will look for items that feel thoughtful and versatile."
  }
};

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
  hideExistingChat();
  injectDomengContext();
  createDomengWidget();
  improveLabels();
});

  function getDomengMemoryEmail() {
  try {
    return localStorage.getItem(DOMENG_MEMORY_EMAIL_KEY) || "";
  } catch (e) {
    return "";
  }
}

function setDomengMemoryEmail(email) {
  try {
    localStorage.setItem(DOMENG_MEMORY_EMAIL_KEY, String(email || "").trim().toLowerCase());
  } catch (e) {}
}

function clearDomengMemoryEmail() {
  try {
    localStorage.removeItem(DOMENG_MEMORY_EMAIL_KEY);
  } catch (e) {}
}

function isValidDomengEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
}

function maskDomengEmail(email) {
  const value = String(email || "").trim();
  const parts = value.split("@");

  if (parts.length !== 2) return value;

  const name = parts[0];
  const domain = parts[1];

  const maskedName =
    name.length <= 2
      ? name.charAt(0) + "*"
      : name.charAt(0) + "***" + name.charAt(name.length - 1);

  return maskedName + "@" + domain;
}

  function getCustomer() {
    return window.MFB_DOMENG_CUSTOMER || {
      loggedIn: false,
      customerId: null,
      firstName: null,
      loginUrl: "/account/login",
      registerUrl: "/account/register",
      accountUrl: "/account"
    };
  }

  function getProduct() {
    return window.MFB_DOMENG_PRODUCT || null;
  }

function getWelcomeMessage() {
    const customer = getCustomer();
    const name = customer.firstName ? `, ${escapeHtml(customer.firstName)}` : "";

    if (customer.loggedIn) {
      return `Welcome back${name}! I'm ${DOMENG_HTML}, your private stylist here at Michelle Francisco Beauty. What can I help you find today?`;
    }

    return `Hi, I'm ${DOMENG_HTML} — your AI stylist here at Michelle Francisco Beauty. Tell me your mood, occasion, or what you're shopping for, and I'll pull together some pieces for you.`;
  }

  function hideExistingChat() {
    const style = document.createElement("style");
    style.innerHTML = `
      #ShopifyChat,
      .shopify-chat,
      .shopify-chat-button,
      iframe[title*="chat" i],
      iframe[src*="inbox.shopify"],
      iframe[src*="shopifychat"],
      div[id*="shopify-chat" i],
      div[class*="shopify-chat" i],
      .mfb-sticky-product-cta {
        display: none !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function injectDomengContext() {
    if (document.getElementById("mfb-domeng-ai-context")) return;

    const context = document.createElement("script");
    context.type = "application/ld+json";
    context.id = "mfb-domeng-ai-context";
    context.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "OnlineStore",
      name: "Michelle Francisco Beauty",
      url: window.location.origin,
      description:
        "Michelle Francisco Beauty is a fashion, beauty, and lifestyle boutique curated around elegance, confidence, softness, and quiet power.",
      brand: {
        "@type": "Brand",
        name: "Michelle Francisco Beauty",
        slogan: "Elegance, curated daily."
      },
      potentialAction: [
        {
          "@type": "SearchAction",
          target: window.location.origin + "/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      ],
      assistant: {
        "@type": "SoftwareApplication",
        name: DOMENG_TEXT,
        applicationCategory: "AI shopping assistant",
        operatingSystem: "Web"
      }
    });

    document.head.appendChild(context);

    const meta = document.createElement("meta");
    meta.name = "domeng-context";
    meta.content =
      "Star is the AI shopping assistant of Michelle Francisco Beauty. It helps shoppers discover products, choose sizes, check shipping eligibility, track orders, buy gift cards, and join the Ambassador Program.";
    document.head.appendChild(meta);
  }

  function createDomengWidget() {
    if (document.querySelector(".domeng-mfb")) return;

    const css = document.createElement("style");
    css.innerHTML = `
      .domeng-mfb {
  position: fixed;
  right: 18px;
  bottom: 34px;
  z-index: 999999;
  font-family: inherit;
}

      .domeng-mfb__launcher {
        border: 0;
        border-radius: 999px;
        padding: 12px 16px;
        background:
          linear-gradient(135deg, #111111 0%, #3b255d 45%, #b59ae6 100%);
        color: #ffffff;
        box-shadow: 0 18px 48px rgba(61,37,93,.28);
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        border: 1px solid rgba(255,255,255,.25);
      }

      .domeng-mfb__orb {
        width: 30px;
        height: 30px;
        border-radius: 999px;
        background:
          radial-gradient(circle at 30% 25%, #ffffff 0%, #f4e8c9 22%, #c8a44d 42%, #7f5eb8 72%, #111111 100%);
        box-shadow: inset 0 0 0 1px rgba(255,255,255,.35);
        flex: 0 0 auto;
      }

      .domeng-mfb__launcher-text {
        display: flex;
        flex-direction: column;
        text-align: left;
        line-height: 1.05;
      }

      .domeng-mfb__launcher-text strong {
        font-size: 14px;
        letter-spacing: .12em;
      }

      .domeng-mfb__launcher-text span {
        font-size: 10px;
        opacity: .82;
        letter-spacing: .08em;
        text-transform: uppercase;
      }

      .domeng-mfb__panel {
        position: absolute;
        right: 0;
        bottom: 66px;
        width: min(470px, calc(100vw - 36px));
        height: min(700px, calc(100vh - 145px));
        background:
          radial-gradient(circle at top left, rgba(181,154,230,.28), transparent 18rem),
          linear-gradient(180deg, rgba(255,255,255,.99), rgba(250,246,255,.99));
        border: 1px solid rgba(91,55,140,.18);
        border-radius: 30px;
        box-shadow: 0 28px 90px rgba(17,17,17,.24);
        overflow: hidden;
        transform: translateY(12px) scale(.96);
        transform-origin: bottom right;
        opacity: 0;
        pointer-events: none;
        transition: transform .22s ease, opacity .22s ease;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) auto;
        box-sizing: border-box;
      }

      .domeng-mfb.is-open .domeng-mfb__panel {
        transform: translateY(0) scale(1);
        opacity: 1;
        pointer-events: auto;
      }

      .domeng-mfb__header {
        grid-row: 1;
        position: relative;
        z-index: 10;
        padding: 18px 18px 14px;
        color: #ffffff;
        background:
          linear-gradient(135deg, #111111 0%, #3b255d 62%, #7f5eb8 100%);
        border-bottom: 1px solid rgba(255,255,255,.12);
        box-shadow: 0 8px 20px rgba(33,23,44,.12);
        box-sizing: border-box;
      }

      .domeng-mfb__topline {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }

      .domeng-mfb__brand {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .domeng-mfb__brand-title {
        display: flex;
        flex-direction: column;
        line-height: 1.12;
      }

      .domeng-mfb__brand-title strong {
        font-size: 16px;
        letter-spacing: .08em;
      }

      .domeng-mfb__brand-title span {
        font-size: 10px;
        opacity: .78;
        text-transform: uppercase;
        letter-spacing: .12em;
      }

      .domeng-mfb__close {
        width: 34px;
        height: 34px;
        border-radius: 999px;
        border: 1px solid rgba(255,255,255,.22);
        background: rgba(255,255,255,.08);
        color: #ffffff;
        cursor: pointer;
        font-size: 18px;
      }

      .domeng-mfb__status {
        margin-top: 12px;
        font-size: 11px;
        color: rgba(255,255,255,.78);
      }

      .domeng-mfb__status:before {
        content: "";
        display: inline-block;
        width: 7px;
        height: 7px;
        border-radius: 99px;
        background: #7cffb2;
        margin-right: 7px;
      }

      .domeng-mfb__body {
        grid-row: 2;
        position: relative;
        z-index: 1;
        padding: 18px 16px 26px;
        overflow-y: auto;
        min-height: 0;
        max-height: none;
        scroll-behavior: smooth;
        box-sizing: border-box;
      }

      .domeng-mfb__body > *:first-child {
      margin-top: 0 !important;
      }

      .domeng-mfb__body .domeng-mfb__message:first-child {
        margin-top: 0 !important;
      }

      .domeng-mfb__body::-webkit-scrollbar {
        width: 7px;
      }

      .domeng-mfb__body::-webkit-scrollbar-track {
        background: rgba(181,154,230,.10);
        border-radius: 999px;
      }

      .domeng-mfb__body::-webkit-scrollbar-thumb {
        background: rgba(127,94,184,.42);
        border-radius: 999px;
      }

      .domeng-mfb__message {
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .domeng-mfb__message--bot {
        align-items: flex-start;
      }

      .domeng-mfb__message--user {
        align-items: flex-end;
      }

      .domeng-mfb__bubble {
  max-width: 88%;
        padding: 12px 14px;
        border-radius: 18px;
        font-size: 13px;
        line-height: 1.55;
        white-space: pre-line;
      }

      .domeng-mfb__bubble a {
        color: #5d3f8f;
        font-weight: 700;
      }

      .domeng-mfb__message--bot .domeng-mfb__bubble {
        background: #ffffff;
        border: 1px solid rgba(91,55,140,.14);
        color: #21172c;
        box-shadow: 0 10px 24px rgba(61,37,93,.06);
      }

      .domeng-mfb__message--user .domeng-mfb__bubble {
        background: linear-gradient(135deg, #7f5eb8, #b59ae6);
        color: #ffffff;
      }

      .domeng-mfb__chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin: 12px 0 4px;
      }

      .domeng-mfb__chip {
        border: 1px solid rgba(200,164,77,.42);
        background: rgba(255,255,255,.78);
        color: #21172c;
        border-radius: 999px;
        padding: 8px 11px;
        font-size: 11px;
        letter-spacing: .04em;
        cursor: pointer;
      }

      .domeng-mfb__account-prompt {
        background: linear-gradient(135deg, rgba(255,255,255,.92), rgba(243,236,253,.92));
        border: 1px solid rgba(91,55,140,.16);
        border-radius: 18px;
        padding: 12px;
        margin: 12px 0;
        color: #21172c;
        box-shadow: 0 10px 24px rgba(61,37,93,.06);
      }

      .domeng-mfb__account-prompt strong {
        display: block;
        font-size: 13px;
        margin-bottom: 5px;
        color: #3b255d;
      }

      .domeng-mfb__account-prompt span {
        display: block;
        font-size: 12px;
        line-height: 1.45;
        color: #6f6377;
      }

      .domeng-mfb__account-prompt small {
        display: block;
        margin-top: 8px;
        font-size: 10px;
        line-height: 1.35;
        color: #7f5eb8;
      }

      .domeng-mfb__memory-login-form {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.domeng-mfb__memory-login-form input {
  flex: 1;
  border: 1px solid rgba(91,55,140,.18);
  background: #ffffff;
  border-radius: 999px;
  padding: 10px 12px;
  color: #21172c;
  outline: none;
  font-size: 12px;
  min-width: 0;
}

.domeng-mfb__memory-login-form button,
.domeng-mfb__account-actions button {
  border: 0;
  border-radius: 999px;
  padding: 10px 12px;
  background: #111111;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .06em;
  cursor: pointer;
  white-space: nowrap;
}

      .domeng-mfb__account-actions {
        display: flex;
        gap: 8px;
        margin-top: 10px;
      }

      .domeng-mfb__account-actions a {
        flex: 1;
        text-align: center;
        border-radius: 999px;
        padding: 9px 10px;
        text-decoration: none;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
      }

      .domeng-mfb__account-actions a:first-child {
        background: #111111;
        color: #ffffff;
      }

      .domeng-mfb__account-actions a:last-child {
        background: #f4e8c9;
        color: #111111;
        border: 1px solid rgba(200,164,77,.45);
      }

      .domeng-mfb__account-prompt--signedin {
        background: linear-gradient(135deg, rgba(244,232,201,.9), rgba(250,246,255,.94));
        border-color: rgba(200,164,77,.36);
      }

      .domeng-mfb__product-card {
        background: rgba(255,255,255,.92);
        border: 1px solid rgba(91,55,140,.14);
        border-radius: 18px;
        padding: 12px;
        margin: 12px 0;
      }

      .domeng-mfb__product-card strong {
        display: block;
        color: #21172c;
        font-size: 13px;
        margin-bottom: 5px;
      }

      .domeng-mfb__product-card span {
        display: block;
        color: #6f6377;
        font-size: 12px;
        line-height: 1.45;
      }

            .domeng-mfb__bubble--loading {
        opacity: .82;
        font-style: italic;
      }

      .domeng-mfb__suggestions {
  display: grid;
  gap: 10px;
  margin-top: 12px;
  width: 100%;
  max-width: 100%;
}

      .domeng-mfb__suggestion-card {
        display: grid;
        grid-template-columns: 78px 1fr;
        gap: 12px;
        align-items: start;
        text-decoration: none !important;
        background: rgba(255,255,255,.96);
        border: 1px solid rgba(91,55,140,.12);
        border-radius: 18px;
        padding: 10px;
        box-shadow: 0 12px 24px rgba(17,17,17,.06);
        transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
      }

      .domeng-mfb__suggestion-card:hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 32px rgba(17,17,17,.10);
        border-color: rgba(127,94,184,.28);
      }

      .domeng-mfb__suggestion-thumb {
        width: 78px;
        height: 78px;
        border-radius: 14px;
        overflow: hidden;
        background: linear-gradient(135deg, #f4edff 0%, #efe5ff 100%);
        border: 1px solid rgba(181,154,230,.18);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .domeng-mfb__suggestion-thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .domeng-mfb__suggestion-thumb-placeholder {
        font-size: 11px;
        letter-spacing: .12em;
        color: #7f5eb8;
        text-transform: uppercase;
        font-weight: 700;
      }

      .domeng-mfb__suggestion-content {
        min-width: 0;
      }

      .domeng-mfb__suggestion-title {
        color: #18111f;
        font-size: 13px;
        font-weight: 700;
        line-height: 1.35;
        margin-bottom: 4px;
      }

      .domeng-mfb__suggestion-desc {
        color: #5f536c;
        font-size: 12px;
        line-height: 1.5;
        margin-bottom: 8px;
      }

      .domeng-mfb__suggestion-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
      }

      .domeng-mfb__suggestion-link {
        color: #7f5eb8;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
      }

      .domeng-mfb__suggestion-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.domeng-mfb__suggestion-add {
  border: 0;
  border-radius: 999px;
  padding: 7px 10px;
  background: #111111;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
}

.domeng-mfb__suggestion-add[disabled] {
  opacity: .55;
  cursor: not-allowed;
}

      .domeng-mfb__suggestion-price {
        color: #111111;
        font-size: 12px;
        font-weight: 700;
        white-space: nowrap;
      }

      .domeng-mfb__memory-card {
  background: linear-gradient(135deg, rgba(255,255,255,.96), rgba(250,246,255,.96));
  border: 1px solid rgba(127,94,184,.16);
  border-radius: 18px;
  padding: 12px;
  margin: 12px 0;
  color: #21172c;
  box-shadow: 0 10px 24px rgba(61,37,93,.05);
}

.domeng-mfb__memory-card strong {
  display: block;
  font-size: 13px;
  color: #3b255d;
  margin-bottom: 6px;
}

.domeng-mfb__memory-card span {
  display: block;
  font-size: 12px;
  color: #6f6377;
  line-height: 1.45;
  margin-bottom: 8px;
}

.domeng-mfb__memory-scroll {
  max-height: 150px;
  overflow-y: auto;
  border-top: 1px solid rgba(91,55,140,.10);
  padding-top: 8px;
}

.domeng-mfb__memory-line {
  font-size: 11px;
  line-height: 1.45;
  color: #5f536c;
  margin-bottom: 6px;
}

.domeng-mfb__memory-line b {
  color: #3b255d;
}

.domeng-mfb__footer {
  grid-row: 3;
  position: relative;
  z-index: 20;
  border-top: 1px solid rgba(91,55,140,.14);
  padding: 12px;
  background: rgba(255,255,255,.98);
  backdrop-filter: blur(14px);
  box-shadow: 0 -10px 24px rgba(61,37,93,.08);
  box-sizing: border-box;
}

.domeng-mfb__body > *:last-child {
  margin-bottom: 0 !important;
}

.domeng-mfb__memory-card,
.domeng-mfb__account-prompt,
.domeng-mfb__product-card {
  position: relative;
  z-index: 1;
}

.domeng-mfb.is-open .domeng-mfb__launcher {
  display: none;
}

.domeng-mfb__message {
  width: 100%;
}

.domeng-mfb__suggestion-card {
  width: 100%;
}

.domeng-mfb__suggestion-desc {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.domeng-mfb__form {
  display: flex;
  gap: 8px;
}

.domeng-mfb__input-wrap {
  position: relative;
  flex: 1;
}

.domeng-mfb__fake-placeholder {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #7d7188;
  font-size: 13px;
  pointer-events: none;
  z-index: 2;
  opacity: .82;
}

.domeng-mfb__input-wrap:focus-within .domeng-mfb__fake-placeholder,
.domeng-mfb__input-wrap.has-value .domeng-mfb__fake-placeholder {
  display: none;
}

      .domeng-mfb__input {
        flex: 1;
        border: 1px solid rgba(91,55,140,.18);
        background: #ffffff;
        border-radius: 999px;
        padding: 12px 14px;
        color: #21172c;
        outline: none;
        font-size: 13px;
        width: 100%;
      }

.domeng-mfb__send {
        border: 0;
        border-radius: 999px;
        padding: 0 16px;
        background: #111111;
        color: #ffffff;
        font-size: 12px;
        letter-spacing: .10em;
        text-transform: uppercase;
        cursor: pointer;
      }

      .domeng-mfb__mic {
        border: 0;
        border-radius: 999px;
        min-width: 46px;
        background: rgba(91,55,140,.10);
        color: #3b255d;
        font-size: 16px;
        cursor: pointer;
      }

      .domeng-mfb__mic.is-listening {
        background: #7f5eb8;
        color: #ffffff;
      }

      .domeng-mfb__wake-row {
        text-align: center;
        margin-top: 8px;
      }

      .domeng-mfb__wake-toggle {
        border: 1px solid rgba(91,55,140,.18);
        background: rgba(255,255,255,.7);
        color: #6f6377;
        border-radius: 999px;
        padding: 6px 12px;
        font-size: 11px;
        cursor: pointer;
      }

      .domeng-mfb__wake-toggle.is-active {
        background: #f4e8c9;
        border-color: rgba(200,164,77,.5);
        color: #3b255d;
      }

      .domeng-mfb__links {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        margin-top: 10px;
        justify-content: center;
      }

      .domeng-mfb__links a {
        color: #5d3f8f;
        font-size: 11px;
        text-decoration: none;
        font-weight: 700;
      }

            @media (max-width: 749px) {
        .domeng-mfb {
          right: 12px;
          bottom: 24px;
        }

        .domeng-mfb__launcher-text span {
          display: none;
        }

        .domeng-mfb__panel {
  width: calc(100vw - 24px);
  height: calc(100vh - 120px);
  right: -2px;
  bottom: 64px;
  border-radius: 24px;
}

        .domeng-mfb__body {
          max-height: none;
          flex: 1 1 auto;
          min-height: 0;
        }

        .domeng-mfb__suggestion-card {
          grid-template-columns: 64px 1fr;
        }

        .domeng-mfb__suggestion-thumb {
          width: 64px;
          height: 64px;
        }
      }
    `;
    document.head.appendChild(css);

    const widget = document.createElement("div");
    widget.className = "domeng-mfb";
    widget.innerHTML = `
      <div class="domeng-mfb__panel" role="dialog" aria-label="STAR AI shopping assistant">
        <div class="domeng-mfb__header">
          <div class="domeng-mfb__topline">
            <div class="domeng-mfb__brand">
              <div class="domeng-mfb__orb"></div>
              <div class="domeng-mfb__brand-title">
                <strong>${DOMENG_HTML}</strong>
                <span>Michelle Francisco Beauty</span>
              </div>
            </div>
            <button class="domeng-mfb__close" type="button" aria-label="Close STAR">×</button>
          </div>
          <div class="domeng-mfb__status">Online • Fashion, beauty, sizing, shipping, order help</div>
        </div>

        <div class="domeng-mfb__body">
          <div class="domeng-mfb__message domeng-mfb__message--bot">
            <div class="domeng-mfb__bubble">${getWelcomeMessage()}</div>
          </div>

          ${getCustomer().loggedIn ? "" : `<div data-domeng-memory-login>${getDomengMemoryLoginHtml()}</div>`}
          <div class="domeng-mfb__memory" data-domeng-memory></div>
          ${getCurrentProductHtml()}

          <div class="domeng-mfb__chips">
            ${DOMENG_CONFIG.quickActions
              .map(action => `<button class="domeng-mfb__chip" type="button">${escapeHtml(action)}</button>`)
              .join("")}
          </div>
        </div>

<div class="domeng-mfb__footer">
          <form class="domeng-mfb__form">
            <div class="domeng-mfb__input-wrap">
  <span class="domeng-mfb__fake-placeholder">Ask STAR...</span>
  <input class="domeng-mfb__input" type="text" placeholder="" aria-label="Ask STAR">
</div>
            <button class="domeng-mfb__mic" type="button" aria-label="Speak to STAR">🎙️</button>
            <button class="domeng-mfb__send" type="submit">Send</button>
          </form>
          <div class="domeng-mfb__wake-row">
            <button class="domeng-mfb__wake-toggle" type="button">🔔 Say “Hi, Star!” to talk hands-free</button>
          </div>
          <div class="domeng-mfb__links">
            <a href="${DOMENG_CONFIG.links.shopAll}">Shop All</a>
            <a href="${DOMENG_CONFIG.links.trackOrder}">Track Order</a>
            <a href="${DOMENG_CONFIG.links.ambassador}">Ambassador</a>
            <a href="${DOMENG_CONFIG.links.contact}">Contact</a>
          </div>
        </div>
      </div>

      <button class="domeng-mfb__launcher" type="button" aria-label="Open STAR">
        <div class="domeng-mfb__orb"></div>
        <div class="domeng-mfb__launcher-text">
          <strong>${DOMENG_HTML}</strong>
          <span>Ask your AI stylist</span>
        </div>
      </button>
    `;

    document.body.appendChild(widget);

    const launcher = widget.querySelector(".domeng-mfb__launcher");
    const close = widget.querySelector(".domeng-mfb__close");
    const form = widget.querySelector(".domeng-mfb__form");
    const input = widget.querySelector(".domeng-mfb__input");
    const body = widget.querySelector(".domeng-mfb__body");
    const inputWrap = widget.querySelector(".domeng-mfb__input-wrap");
    const memoryBox = widget.querySelector("[data-domeng-memory]");
    const memoryLoginBox = widget.querySelector("[data-domeng-memory-login]");

if (input && inputWrap) {
  input.addEventListener("input", function () {
    inputWrap.classList.toggle("has-value", input.value.trim().length > 0);
  });
}

if (memoryLoginBox) {
  memoryLoginBox.addEventListener("submit", function (event) {
    const form = event.target.closest("[data-domeng-memory-login-form]");
    if (!form) return;

    event.preventDefault();

    const emailInput = form.querySelector("[data-domeng-memory-email]");
    const email = emailInput ? emailInput.value.trim().toLowerCase() : "";

    if (!isValidDomengEmail(email)) {
      addMessage("Please enter a valid email address so Star can link your private memory.", "bot");
      return;
    }

    setDomengMemoryEmail(email);

    memoryLoginBox.innerHTML = getDomengMemoryLoginHtml();

    addMessage(`Star memory is now linked to ${escapeHtml(maskDomengEmail(email))}. I can now save and reload your shopping conversations for this email.`, "bot");

    saveDomengLocalConversation(
      "Star memory email connected",
      "Star memory is now linked to this email."
    ).then(function () {
      loadDomengPersistentMemory();
    });
  });

  memoryLoginBox.addEventListener("click", function (event) {
    const clearButton = event.target.closest("[data-domeng-memory-clear]");
    if (!clearButton) return;

    clearDomengMemoryEmail();
    memoryLoginBox.innerHTML = getDomengMemoryLoginHtml();
    memoryBox.innerHTML = "";

    addMessage("Star memory email was removed from this browser. Enter an email again to reload private memory.", "bot");
  });
}

    launcher.addEventListener("click", () => {
      widget.classList.toggle("is-open");
      setTimeout(() => input.focus(), 120);
    });

close.addEventListener("click", () => widget.classList.remove("is-open"));
    loadDomengPersistentMemory();

    (function setupStarVoiceInput() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const micButton = widget.querySelector(".domeng-mfb__mic");
      const wakeButton = widget.querySelector(".domeng-mfb__wake-toggle");

      if (!SpeechRecognition) {
        if (micButton) micButton.style.display = "none";
        if (wakeButton) wakeButton.style.display = "none";
        return;
      }

      // --- Tap-to-talk mic (fills the input, user still hits Send) ---
      const dictation = new SpeechRecognition();
      dictation.lang = "en-US";
      dictation.interimResults = false;
      dictation.maxAlternatives = 1;
      let isDictating = false;

      micButton.addEventListener("click", function () {
        if (isDictating) { dictation.stop(); return; }
        dictation.start();
      });

      dictation.addEventListener("start", function () {
        console.log("STAR: dictation started successfully");
        isDictating = true;
        micButton.classList.add("is-listening");
      });

      dictation.addEventListener("end", function () {
        isDictating = false;
        micButton.classList.remove("is-listening");

        if (wakeActive) {
          wakeTriggered = false;
          setTimeout(() => {
            startWakeListening();
          }, 500);
        }
      });

let isWakeDictation = false;

      dictation.addEventListener("result", function (event) {
        const transcript = event.results[0][0].transcript;

        if (isWakeDictation) {
          isWakeDictation = false;
          handleDomengQuery(transcript);
          return;
        }

        input.value = transcript;
        if (inputWrap) inputWrap.classList.add("has-value");
        input.focus();
      });

      dictation.addEventListener("error", function (event) {
        console.log("STAR: dictation ERROR", event.error);
        isDictating = false;
        micButton.classList.remove("is-listening");
      });

      // --- "Hi, Star!" wake-word listener (opt-in, continuous) ---
      let wakeActive = false;
      let wakeRecognition = null;
      let wakeShouldRestart = false;

      function startWakeListening() {
        wakeRecognition = new SpeechRecognition();
        wakeRecognition.lang = "en-US";
        wakeRecognition.continuous = true;
        wakeRecognition.interimResults = true;

let wakeTriggered = false;

        wakeRecognition.addEventListener("result", function (event) {
          for (let i = event.resultIndex; i < event.results.length; i++) {
            if (!event.results[i].isFinal) continue;

            const rawPhrase = event.results[i][0].transcript;
            const phrase = rawPhrase.toLowerCase().replace(/[^\w\s]/g, "").trim();
            console.log("STAR wake-word heard (final):", phrase);

            if (
              !wakeTriggered &&
              (phrase.includes("hi star") || phrase.includes("hey star") || phrase.includes("hi stars"))
            ) {
              wakeTriggered = true;

              wakeShouldRestart = false;
              try { wakeRecognition.stop(); } catch (e) {}

              widget.classList.add("is-open");

              const greetMsg = addMessage("Yes? I'm listening — go ahead!", "bot");
              const greetVoiceBtn = greetMsg.querySelector("button");
              if (greetVoiceBtn) starPlayVoice(greetVoiceBtn, greetVoiceBtn._speakText);

          isWakeDictation = true;
              console.log("STAR: about to start dictation after wake-word, isWakeDictation =", isWakeDictation);

              setTimeout(() => {
                input.focus();
                console.log("STAR: calling dictation.start() now");
                try {
                  dictation.start();
                } catch (err) {
                  console.log("STAR: dictation.start() FAILED", err);
                }
              }, 1500);
            }
          }
        });

        wakeRecognition.addEventListener("end", function () {
          if (wakeShouldRestart) {
            try { wakeRecognition.start(); } catch (e) {}
          }
        });

        wakeRecognition.addEventListener("error", function () {
          if (wakeShouldRestart) {
            setTimeout(() => {
              try { wakeRecognition.start(); } catch (e) {}
            }, 1000);
          }
        });

wakeShouldRestart = true;
        console.log("STAR wake listener: starting...");
        try {
          wakeRecognition.start();
          console.log("STAR wake listener: start() called successfully");
        } catch (err) {
          console.log("STAR wake listener: start() FAILED", err);
        }
      }

      function stopWakeListening() {
        wakeShouldRestart = false;
        if (wakeRecognition) {
          try { wakeRecognition.stop(); } catch (e) {}
        }
      }

      wakeButton.addEventListener("click", function () {
        wakeActive = !wakeActive;
        wakeButton.classList.toggle("is-active", wakeActive);
        wakeButton.textContent = wakeActive
          ? "🔔 Listening for “Hi, Star!”"
          : "🔔 Say “Hi, Star!” to talk hands-free";

        if (wakeActive) {
          startWakeListening();
        } else {
          stopWakeListening();
        }
      });
    })();

    widget.querySelectorAll(".domeng-mfb__chip").forEach(chip => {
      chip.addEventListener("click", () => {
        const text = chip.textContent.trim();
        handleDomengQuery(text);
      });
    });

    body.addEventListener("click", function (event) {
  const button = event.target.closest("[data-domeng-add-to-bag]");

  if (!button) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  handleDomengAddToBag(button);
});

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      const query = input.value.trim();
      if (!query) return;
      input.value = "";
      if (inputWrap) inputWrap.classList.remove("has-value");
      handleDomengQuery(query);
    });

async function fetchDomengDirectMensTops(limit = 4) {
  try {
    const finalItems = [];
    const seenHandles = new Set();

    for (let page = 1; page <= 4; page++) {
      const response = await fetch(`/products.json?limit=250&page=${page}`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) {
        break;
      }

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];

      if (!products.length) {
        break;
      }

      products.forEach(function (product) {
        const productText = normalizeDomengSearchText([
          product.title,
          product.product_type,
          product.vendor,
          product.tags,
          product.body_html
        ].join(" "));

        const isMens =
          productText.includes("men s") ||
          domengHasWholeTerm(productText, "men") ||
          domengHasWholeTerm(productText, "mens") ||
          domengHasWholeTerm(productText, "male");

        const isWomens =
          productText.includes("women s") ||
          domengHasWholeTerm(productText, "women") ||
          domengHasWholeTerm(productText, "womens") ||
          domengHasWholeTerm(productText, "female");

        const isTop =
          domengHasWholeTerm(productText, "shirt") ||
          domengHasWholeTerm(productText, "shirts") ||
          domengHasWholeTerm(productText, "button shirt") ||
          domengHasWholeTerm(productText, "top") ||
          domengHasWholeTerm(productText, "tops");

        const isFootwear =
  domengHasWholeTerm(productText, "shoe") ||
  domengHasWholeTerm(productText, "shoes") ||
  domengHasWholeTerm(productText, "sneaker") ||
  domengHasWholeTerm(productText, "sneakers") ||
  domengHasWholeTerm(productText, "athletic shoes") ||
  domengHasWholeTerm(productText, "footwear");

const isDressLike =
  domengHasWholeTerm(productText, "dress") ||
  domengHasWholeTerm(productText, "dresses") ||
  productText.includes("tee dress") ||
  productText.includes("lounge tee dress");

const wantsPlusSize =
  q.includes("plus size") ||
  q.includes("plus-size") ||
  q.includes("big and tall") ||
  q.includes("big & tall");

const isPlusSize =
  productText.includes("plus size") ||
  productText.includes("big and tall") ||
  productText.includes("big tall");

const isBetterMensTop =
  domengHasWholeTerm(productText, "shirt") ||
  domengHasWholeTerm(productText, "shirts") ||
  domengHasWholeTerm(productText, "button shirt") ||
  domengHasWholeTerm(productText, "button shirts") ||
  domengHasWholeTerm(productText, "polo") ||
  domengHasWholeTerm(productText, "tee") ||
  domengHasWholeTerm(productText, "t shirt") ||
  domengHasWholeTerm(productText, "tshirt");

if (!isMens || isWomens || !isBetterMensTop || isFootwear || isDressLike) {
  return;
}

        if (!product.handle || seenHandles.has(product.handle)) {
          return;
        }

        const firstAvailableVariant =
          Array.isArray(product.variants)
            ? product.variants.find(function (variant) {
                return variant && variant.available !== false;
              }) || product.variants[0]
            : null;

        const rawImage =
          product.image && product.image.src
            ? product.image.src
            : Array.isArray(product.images) && product.images[0]
              ? product.images[0].src
              : "";

        const rawPrice =
          firstAvailableVariant && firstAvailableVariant.price
            ? firstAvailableVariant.price
            : product.variants && product.variants[0]
              ? product.variants[0].price
              : "";

        seenHandles.add(product.handle);

        finalItems.push({
          title: product.title || "Men’s Shirt",
          url: `/products/${product.handle}`,
          image: normalizeDomengImageUrl(rawImage),
          description: truncateText(stripHtml(product.body_html || "A curated men’s Michelle Francisco Beauty piece."), 105),
          price: rawPrice ? formatMoney(Number(rawPrice) * 100) : "",
          priceValue: rawPrice ? Number(rawPrice) : null,
          variantId:
            firstAvailableVariant && firstAvailableVariant.id
              ? firstAvailableVariant.id
              : "",
          product_type: product.product_type || "",
          vendor: product.vendor || "",
          tags: Array.isArray(product.tags) ? product.tags.join(" ") : String(product.tags || "")
        });
      });

      if (finalItems.length >= limit) {
        break;
      }
    }

    return finalItems.slice(0, limit);
  } catch (error) {
    console.error("DOMENG direct mens tops search failed:", error);
    return [];
  }
}

async function fetchDomengProductsFromSearchPage(searchQuery, limit = 8) {
  const results = [];
  const seenHandles = new Set();

  try {
    const response = await fetch(`/search?q=${encodeURIComponent(searchQuery)}&type=product`, {
      method: "GET",
      credentials: "same-origin"
    });

    if (!response.ok) {
      return results;
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const links = Array.from(doc.querySelectorAll('a[href*="/products/"]'));

    for (const link of links) {
      const href = link.getAttribute("href") || "";
      const match = href.match(/\/products\/([^?#/]+)/);

      if (!match || !match[1]) {
        continue;
      }

      const handle = match[1];

      if (seenHandles.has(handle)) {
        continue;
      }

      seenHandles.add(handle);

      try {
        const productResponse = await fetch(`/products/${handle}.js`, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            "Accept": "application/json"
          }
        });

        if (!productResponse.ok) {
          continue;
        }

        const product = await productResponse.json();

        const firstAvailableVariant =
          Array.isArray(product.variants)
            ? product.variants.find(function (variant) {
                return variant && variant.available !== false;
              }) || product.variants[0]
            : null;

        if (!firstAvailableVariant || !firstAvailableVariant.id) {
          continue;
        }

        const rawImage =
          product.featured_image ||
          product.image ||
          (Array.isArray(product.images) && product.images[0] ? product.images[0] : "");

        const rawPrice = firstAvailableVariant.price || product.price || 0;
        const cents = Number(rawPrice || 0);
        const priceValue = cents > 1000 ? cents / 100 : cents;

        results.push({
          title: product.title || "Suggested Item",
          url: `/products/${handle}`,
          image: normalizeDomengImageUrl(rawImage),
          description: truncateText(stripHtml(product.description || product.body_html || "A curated Michelle Francisco Beauty piece."), 105),
          price: cents ? formatMoney(cents > 1000 ? cents : cents * 100) : "",
          priceValue,
          variantId: firstAvailableVariant.id,
          product_type: product.type || product.product_type || "",
          vendor: product.vendor || "",
          tags: Array.isArray(product.tags) ? product.tags.join(" ") : String(product.tags || "")
        });

        if (results.length >= limit) {
          break;
        }
      } catch (productError) {
        console.warn("DOMENG search page product hydration failed:", productError);
      }
    }

    return results.slice(0, limit);
  } catch (error) {
    console.error("DOMENG search page scan failed:", error);
    return results;
  }
}

async function handleDomengAddToBag(button) {
  const variantId = button.getAttribute("data-variant-id");
  const productTitle = button.getAttribute("data-product-title") || "This item";
  const originalText = button.textContent;

  if (!variantId) {
    addMessage(`I could not add ${escapeHtml(productTitle)} automatically because the product variant was not available. Please tap “View this piece” and add it from the product page.`, "bot");
    return;
  }

  button.disabled = true;
  button.textContent = "Adding…";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) {
      let errorMessage = "Could not add item to bag.";

      try {
        const errorData = await response.json();
        errorMessage = errorData.description || errorData.message || errorMessage;
      } catch (e) {}

      throw new Error(errorMessage);
    }

    button.textContent = "Added";

    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

    addMessage(`${escapeHtml(productTitle)} has been added to your bag.

<a href="/cart">View Bag</a> or continue shopping with Star.`, "bot");

    saveDomengLocalConversation(
      `Added ${productTitle} to bag`,
      `${productTitle} was added to the shopping bag from Star.`
    ).then(function () {
      loadDomengPersistentMemory();
    });
  } catch (error) {
    console.error("DOMENG add to bag failed:", error);

    button.disabled = false;
    button.textContent = originalText;

    addMessage(`I could not add ${escapeHtml(productTitle)} automatically.

Reason: ${escapeHtml(error.message || "The product may require selecting options on the product page.")}

Please tap “View this piece” and add it from the product page.`, "bot");
  }
}

    async function handleDomengQuery(query) {
  addMessage(query, "user");

  try {
    if (typeof updateDomengSession === "function") {
      updateDomengSession(query);
    }
  } catch (error) {
    console.warn("DOMENG session memory failed:", error);
  }

  const q = String(query || "").toLowerCase();
const product = getProduct();
if (
  q.includes("i'm a man") ||
  q.includes("im a man") ||
  q.includes("i am a man") ||
  q.includes("i am male") ||
  q.includes("male shopper")
) {
  DOMENG_SESSION.lastAudience = "mens";

  const audienceAnswer = `Got it. I will prioritize men’s pieces for this session.

Try:
“Show me men’s shirts”
or
“Show me tops to match my shoes”`;

  addMessage(audienceAnswer, "bot");

  saveDomengLocalConversation(query, audienceAnswer).then(function () {
    loadDomengPersistentMemory();
  });

  return;
}

if (isDomengCartQuery(query)) {
  try {
    const cartAnswer = await answerDomengCartQuestion(query);

    addMessage(cartAnswer, "bot");

    saveDomengLocalConversation(query, cartAnswer).then(function () {
      loadDomengPersistentMemory();
    });

    return;
  } catch (error) {
    console.error("DOMENG cart answer failed:", error);

    addMessage(`I had trouble reading your bag automatically.

Please open your bag here:
<a href="/cart">View Bag</a>

You can also continue shopping and ask me to recommend products.`, "bot");

    return;
  }
}

const directMensTopRequest =
  (
    q.includes("shirt") ||
    q.includes("shirts") ||
    q.includes("top") ||
    q.includes("tops") ||
    q.includes("button shirt") ||
    q.includes("button shirts")
  ) &&
  (
    q.includes("men") ||
    q.includes("mens") ||
    q.includes("men's") ||
    q.includes("man") ||
    q.includes("male") ||
    q.includes("match") ||
    q.includes("pair") ||
    q.includes("with my shoes") ||
    q.includes("to match") ||
    DOMENG_SESSION.lastAudience === "mens" ||
    (
      product &&
      normalizeDomengSearchText([
        product.title,
        product.product_type,
        product.type,
        product.description,
        product.vendor,
        Array.isArray(product.tags) ? product.tags.join(" ") : ""
      ].join(" ")).includes("men s")
    )
  );

if (directMensTopRequest) {
  const loadingMensTopMessage = addMessage("Searching men’s shirts and tops…", "bot", {
    loading: true
  });

  try {
    const wantsPlusSize =
      q.includes("plus size") ||
      q.includes("plus-size") ||
      q.includes("big and tall") ||
      q.includes("big & tall");

    const mensTopSuggestions = [];
    const seenHandles = new Set();
        const searchPageQueries = wantsPlusSize
      ? [
          "plus size men's button shirt",
          "plus size mens button shirt",
          "plus size men's shirt",
          "plus size mens shirt"
        ]
      : [
          "men's button shirt",
          "mens button shirt",
          "men button shirt",
          "men's shirt",
          "mens shirt",
          "men shirt",
          "button shirt"
        ];

    for (const searchPageQuery of searchPageQueries) {
      const searchPageItems = await fetchDomengProductsFromSearchPage(searchPageQuery, 12);

      searchPageItems.forEach(function (item) {
        const titleText = normalizeDomengSearchText(item.title || "");

        const isMens =
          titleText.includes("men s") ||
          titleText.includes("mens") ||
          titleText.includes("men ") ||
          domengHasWholeTerm(titleText, "men") ||
          domengHasWholeTerm(titleText, "mens");

        const isWomens =
          titleText.includes("women s") ||
          titleText.includes("womens") ||
          domengHasWholeTerm(titleText, "women") ||
          domengHasWholeTerm(titleText, "womens");

        const isActualTop =
          titleText.includes("button shirt") ||
          titleText.includes("denim shirt") ||
          titleText.includes("short sleeve") ||
          titleText.includes("long sleeve") ||
          domengHasWholeTerm(titleText, "shirt") ||
          domengHasWholeTerm(titleText, "shirts") ||
          domengHasWholeTerm(titleText, "polo") ||
          domengHasWholeTerm(titleText, "tee") ||
          domengHasWholeTerm(titleText, "tshirt") ||
          domengHasWholeTerm(titleText, "t shirt") ||
          domengHasWholeTerm(titleText, "top") ||
          domengHasWholeTerm(titleText, "tops");

        const isExplicitPlusSize =
          titleText.includes("plus size") ||
          titleText.includes("plus-size") ||
          titleText.includes("big and tall") ||
          titleText.includes("big tall");

        const isBad =
          isWomens ||
          titleText.includes("dress") ||
          titleText.includes("shoe") ||
          titleText.includes("sneaker") ||
          titleText.includes("footwear");

        if (!isMens || !isActualTop || isBad) {
          return;
        }

        if (isExplicitPlusSize && !wantsPlusSize) {
          return;
        }

        const cleanUrl = normalizeDomengProductUrl(item.url);

        if (
          cleanUrl &&
          !mensTopSuggestions.some(function (existing) {
            return normalizeDomengProductUrl(existing.url) === cleanUrl;
          })
        ) {
          let score = 0;

          if (titleText.includes("button shirt")) score += 900;
          if (titleText.includes("denim shirt")) score += 500;
          if (titleText.includes("short sleeve")) score += 300;
          if (titleText.includes("long sleeve")) score += 250;
          if (domengHasWholeTerm(titleText, "shirt")) score += 300;
          if (domengHasWholeTerm(titleText, "polo")) score += 180;
          if (domengHasWholeTerm(titleText, "tee")) score += 100;

          mensTopSuggestions.push(Object.assign({}, item, {
            domengScore: score
          }));
        }
      });

      if (mensTopSuggestions.length >= 8) {
        break;
      }
    }

    if (mensTopSuggestions.length < 4) {
    for (let page = 1; page <= 25; page++) {
      const response = await fetch(`/products.json?limit=250&page=${page}`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) {
        break;
      }

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];

      if (!products.length) {
        break;
      }

      products.forEach(function (catalogProduct) {
        const titleText = normalizeDomengSearchText(catalogProduct.title || "");

        const productText = normalizeDomengSearchText([
          catalogProduct.title,
          catalogProduct.product_type,
          catalogProduct.vendor,
          Array.isArray(catalogProduct.tags) ? catalogProduct.tags.join(" ") : catalogProduct.tags,
          catalogProduct.body_html
        ].join(" "));

        const isMens =
          titleText.includes("men s") ||
          titleText.includes("mens") ||
          titleText.includes("men ") ||
          domengHasWholeTerm(titleText, "men") ||
          domengHasWholeTerm(titleText, "mens");

        const isWomens =
          titleText.includes("women s") ||
          titleText.includes("womens") ||
          domengHasWholeTerm(titleText, "women") ||
          domengHasWholeTerm(titleText, "womens");

        const isActualTop =
          titleText.includes("button shirt") ||
          titleText.includes("denim shirt") ||
          titleText.includes("short sleeve") ||
          titleText.includes("long sleeve") ||
          domengHasWholeTerm(titleText, "shirt") ||
          domengHasWholeTerm(titleText, "shirts") ||
          domengHasWholeTerm(titleText, "polo") ||
          domengHasWholeTerm(titleText, "tee") ||
          domengHasWholeTerm(titleText, "tshirt") ||
          domengHasWholeTerm(titleText, "t shirt") ||
          domengHasWholeTerm(titleText, "top") ||
          domengHasWholeTerm(titleText, "tops");

        const isFootwear =
          domengHasWholeTerm(titleText, "shoe") ||
          domengHasWholeTerm(titleText, "shoes") ||
          domengHasWholeTerm(titleText, "sneaker") ||
          domengHasWholeTerm(titleText, "sneakers") ||
          domengHasWholeTerm(titleText, "athletic shoes") ||
          domengHasWholeTerm(titleText, "footwear");

        const isDressLike =
          domengHasWholeTerm(titleText, "dress") ||
          domengHasWholeTerm(titleText, "dresses") ||
          titleText.includes("tee dress") ||
          titleText.includes("lounge tee dress");

        /*
          Critical:
          Plus Size must be detected from TITLE ONLY.
          Do not use description, tags, size guide, 2XL, 3XL, 4XL, 5XL, or 6XL.
        */
        const isExplicitPlusSize =
          titleText.includes("plus size") ||
          titleText.includes("plus-size") ||
          titleText.includes("big and tall") ||
          titleText.includes("big tall");

        if (!isMens || isWomens || !isActualTop || isFootwear || isDressLike) {
          return;
        }

        if (isExplicitPlusSize && !wantsPlusSize) {
          return;
        }

        if (!catalogProduct.handle || seenHandles.has(catalogProduct.handle)) {
          return;
        }

        const firstAvailableVariant =
          Array.isArray(catalogProduct.variants)
            ? catalogProduct.variants.find(function (variant) {
                return variant && variant.available !== false;
              }) || catalogProduct.variants[0]
            : null;

        if (!firstAvailableVariant || !firstAvailableVariant.id) {
          return;
        }

        const rawImage =
          catalogProduct.image && catalogProduct.image.src
            ? catalogProduct.image.src
            : Array.isArray(catalogProduct.images) && catalogProduct.images[0]
              ? catalogProduct.images[0].src
              : "";

        const rawPrice =
          firstAvailableVariant && firstAvailableVariant.price
            ? firstAvailableVariant.price
            : "";

        let score = 0;

        if (titleText.includes("button shirt")) score += 600;
        if (titleText.includes("denim shirt")) score += 450;
        if (titleText.includes("short sleeve")) score += 250;
        if (titleText.includes("long sleeve")) score += 220;
        if (domengHasWholeTerm(titleText, "shirt")) score += 300;
        if (domengHasWholeTerm(titleText, "polo")) score += 180;
        if (domengHasWholeTerm(titleText, "tee")) score += 120;
        if (domengHasWholeTerm(titleText, "top")) score += 80;

        if (titleText.includes("plus size")) score -= 1000;
        if (titleText.includes("plus-size")) score -= 1000;
        if (titleText.includes("big and tall")) score -= 1000;
        if (titleText.includes("big tall")) score -= 1000;
        if (titleText.includes("dress")) score -= 1000;
        if (titleText.includes("shoe")) score -= 1000;

        seenHandles.add(catalogProduct.handle);

        mensTopSuggestions.push({
          title: catalogProduct.title || "Men’s Shirt",
          url: `/products/${catalogProduct.handle}`,
          image: normalizeDomengImageUrl(rawImage),
          description: truncateText(stripHtml(catalogProduct.body_html || "A curated men’s Michelle Francisco Beauty piece."), 105),
          price: rawPrice ? formatMoney(Number(rawPrice) * 100) : "",
          priceValue: rawPrice ? Number(rawPrice) : null,
          variantId: firstAvailableVariant.id,
          product_type: catalogProduct.product_type || "",
          vendor: catalogProduct.vendor || "",
          tags: Array.isArray(catalogProduct.tags) ? catalogProduct.tags.join(" ") : String(catalogProduct.tags || ""),
          domengScore: score
        });
      });

      const goodRegularCount = mensTopSuggestions.filter(function (item) {
        const titleText = normalizeDomengSearchText(item.title || "");

        const isExplicitPlusSize =
          titleText.includes("plus size") ||
          titleText.includes("plus-size") ||
          titleText.includes("big and tall") ||
          titleText.includes("big tall");

        return !isExplicitPlusSize && item.domengScore > 0;
      }).length;

      if (goodRegularCount >= 8) {
        break;
      }
    }
    }
    const rankedMensTopSuggestions = mensTopSuggestions
      .filter(function (item) {
        return item.domengScore > 0;
      })
      .sort(function (a, b) {
        return b.domengScore - a.domengScore;
      });

    const finalMensTopSuggestions = filterDomengProductsByBudget(rankedMensTopSuggestions, query).slice(0, 4);

    loadingMensTopMessage.remove();

    if (finalMensTopSuggestions.length) {
      const mensTopAnswer = wantsPlusSize
        ? `I found Plus Size men’s shirts and tops to match your shoes. Tap any card to view the item or add it to your bag.`
        : `I found men’s shirts and tops to match your shoes. Tap any card to view the item or add it to your bag.`;

      addMessage(mensTopAnswer, "bot", {
        suggestions: finalMensTopSuggestions
      });

      saveDomengLocalConversation(query, mensTopAnswer).then(function () {
        loadDomengPersistentMemory();
      });

      return;
    }

    const noMensTopAnswer = wantsPlusSize
      ? `I searched the product catalog directly for Plus Size men’s shirts and tops, but I could not find an available Plus Size men’s top right now.

Try:
<a href="/search?q=plus%20size%20men%27s%20shirt&type=product">Search Plus Size Men’s Shirts</a>
or
<a href="/collections/all">Shop All</a>`
      : `I searched the product catalog directly for regular men’s shirts and tops, but I could not find a regular men’s top right now.

Try:
<a href="/search?q=men%27s%20button%20shirt&type=product">Search Men’s Button Shirts</a>
or
<a href="/collections/all">Shop All</a>`;

    addMessage(noMensTopAnswer, "bot");

    saveDomengLocalConversation(query, noMensTopAnswer).then(function () {
      loadDomengPersistentMemory();
    });

    return;
  } catch (error) {
    console.error("DOMENG direct men’s top search failed:", error);

    loadingMensTopMessage.remove();

    addMessage(`I had trouble searching men’s shirts automatically.

Try:
<a href="/search?q=men%27s%20button%20shirt&type=product">Search Men’s Button Shirts</a>`, "bot");

    return;
  }
}

function safeLocalAnswer() {
    try {
      return fallbackAnswer(query);
    } catch (error) {
      console.error("DOMENG fallback failed:", error);

      if (
        q.includes("ambassador") ||
        q.includes("earn") ||
        q.includes("commission") ||
        q.includes("creator") ||
        q.includes("influencer") ||
        q.includes("promote")
      ) {
        return `Michelle Francisco Beauty welcomes style creators, beauty creators, lifestyle voices, shoppers, students, stylists, bloggers, and community leaders to become M Collection Ambassadors.

Ambassadors earn 10% commission on the net product subtotal of eligible referred sales by sharing their unique Ambassador link.

Best ways to promote:
1. Share mood-based edits such as Soft Feminine, Power Woman, Date Night, Vacation, and Minimalist Chic.
2. Post product links with your Ambassador link.
3. Create outfit captions, reels, stories, and gift guides.

Apply here:
<a href="${DOMENG_CONFIG.links.ambassador}" target="_blank" rel="noopener">Become an Ambassador</a>`;
      }

      return `I can help with styling, product discovery, shipping, sizing, orders, gift cards, and the Ambassador Program.

Try asking:
“Find me a soft feminine dress”
“Can this ship to Canada?”
“Give me an Instagram caption”
“Become an Ambassador”`;
    }
  }

  let intent = "general";

  try {
    if (typeof detectDomengIntent === "function") {
      intent = detectDomengIntent(query);
    }
  } catch (error) {
    console.warn("DOMENG intent detection failed:", error);
  }

  const localFirstIntents = [
    "style_quiz",
    "content_help",
    "ambassador",
    "shipping",
    "sizing",
    "order"
  ];

  const localFirstKeywords = [
  "ambassador",
  "ambassador rewards",
  "become an ambassador",
  "how do i earn",
  "earn 10",
  "commission",
  "instagram caption",
  "tiktok",
  "reel script",
  "style quiz",
  "find my style",
  "track order",
  "gift card",
  "login",
  "account",
  "remember",
  "memory",
  "previous",
  "past",
  "what do you remember",
  "what do you know about me",
  "previous conversation",
  "previous conversations",
  "based on my previous",
  "based on my memory",
  "based on what you remember",
  "what should i shop for",
  "show me pieces based on my memory",
  "this product",
  "this item",
  "this piece",
  "current product",
  "current item",
  "tell me about this",
  "summarize this",
  "should i buy this",
  "why should i buy",
  "sell me this",
  "is this good",
  "what can i pair with this",
  "pair with this",
  "style this",
  "complete the look",
  "wear with this",
  "what is in my bag",
  "what's in my bag",
  "what is in my cart",
  "what's in my cart",
  "complete my bag",
  "complete the bag",
  "does my bag match",
  "do these match",
  "should i checkout",
  "ready to checkout",
  "checkout help",
  "find one more",
  "one more piece",
  "i'm a man",
  "im a man",
  "i am a man",
  "i am male",
  "male shopper",
  "i'm a woman",
  "im a woman",
  "i am a woman",
  "i am female",
  "female shopper"
  ];

  const shouldAnswerLocally =
    localFirstIntents.includes(intent) ||
    localFirstKeywords.some(function (word) {
      return q.includes(word);
    });

  if (shouldAnswerLocally) {
    const localAnswer = safeLocalAnswer();
    addMessage(localAnswer, "bot");
    saveDomengLocalConversation(query, localAnswer).then(function () {
      loadDomengPersistentMemory();
    });
    return;
  }

  const loadingMessage = addMessage("Curating suggestions for you…", "bot", {
    loading: true
  });

  try {
    const response = await getDomengAnswer(query);

    let suggestions = Array.isArray(response.suggestions) ? response.suggestions : [];

const isSimilarProductQueryEarly =
  product &&
  (
    q.includes("similar") ||
    q.includes("like this") ||
    q.includes("something like this") ||
    q.includes("more like this") ||
    q.includes("same style") ||
    q.includes("same type")
  );

if (!suggestions.length && isSimilarProductQueryEarly) {
  suggestions = await fetchSimilarProductSuggestions(query, 4);
}

if (!suggestions.length && isProductSuggestionQuery(query)) {
  suggestions = await fetchProductSuggestions(query, 4);

  const isLookRequest =
    !hasStrictProductRequirement(query) &&
    (isMoodQuery(query) ||
      String(query).toLowerCase().includes("outfit") ||
      String(query).toLowerCase().includes("look") ||
      String(query).toLowerCase().includes("style me"));

  if (isLookRequest && suggestions.length) {
    const category = detectCategory(query);
    const complementCategory =
      category === "dress" ? "bag" :
      category === "top" ? "bottom" :
      category === "bag" ? "shoes" :
      "accessories";

    try {
      const complementSuggestions = await fetchProductSuggestions(complementCategory, 2);
      const merged = suggestions.concat(complementSuggestions);
      const seen = new Set();
      suggestions = merged.filter(function (item) {
        const url = normalizeDomengProductUrl(item.url);
        if (seen.has(url)) return false;
        seen.add(url);
        return true;
      }).slice(0, 4);
    } catch (e) {}
  }
}

if (!suggestions.length) {
  suggestions = await fetchDomengGenericProductMatch(query, 4);
}

let siteContentMatch = null;
if (!suggestions.length) {
  try {
    siteContentMatch = await searchDomengSiteContent(query);
  } catch (e) {
    console.warn("STAR site content search failed:", e);
  }
}

    suggestions = await hydrateDomengSuggestions(suggestions);
    suggestions = suggestions.filter(function (item) {
  return isRelevantDomengProduct(item, query);
});

suggestions = filterDomengProductsByBudget(suggestions, query);

    loadingMessage.remove();

    let moodAnswer = "";
    let sessionSummary = "";

    try {
      moodAnswer = getMoodAnswer(query);
      sessionSummary = typeof getSessionStyleSummary === "function" ? getSessionStyleSummary() : "";
    } catch (error) {
      console.warn("DOMENG mood/session summary failed:", error);
    }

    const strictProductRequest = hasStrictProductRequirement(query);
    const budgetText = detectBudget(query) || "";
    const budgetPhrase =
      budgetText && budgetText !== "no budget limit"
        ? `, ${budgetText}`
        : "";

const isSimilarProductQuery =
  product &&
  (
    q.includes("similar") ||
    q.includes("like this") ||
    q.includes("something like this") ||
    q.includes("more like this") ||
    q.includes("same style") ||
    q.includes("same type")
  );

const answerText = suggestions.length
  ? isSimilarProductQuery
    ? `I found similar pieces based on the current product: ${escapeHtml(product.title)}${budgetPhrase}. Tap any card to view the item.`
    : moodAnswer
      ? `${moodAnswer}

I curated these pieces with your mood in mind${sessionSummary ? `, including ${sessionSummary}` : ""}${budgetPhrase}. Tap any card to view the item.`
      : `I found a few pieces that match your request${sessionSummary ? `, based on ${sessionSummary}` : ""}${budgetPhrase}. Tap any card to view the item.`
: strictProductRequest
    ? safeLocalAnswer()
    : siteContentMatch
      ? `Here's what I found on our ${escapeHtml(siteContentMatch.title)} page:\n\n${escapeHtml(siteContentMatch.snippet)}...\n\n<a href="${escapeHtml(siteContentMatch.url)}">Read the full page</a>`
      : response.answer && response.answer.trim()
        ? response.answer
        : safeLocalAnswer();

addMessage(answerText, "bot", {
  suggestions: suggestions
});

saveDomengLocalConversation(query, answerText).then(function () {
  loadDomengPersistentMemory();
});
  } catch (error) {
    console.error("DOMENG failed:", error);

    loadingMessage.remove();

    const fallbackAnswerText = safeLocalAnswer();

addMessage(fallbackAnswerText, "bot");

saveDomengLocalConversation(query, fallbackAnswerText).then(function () {
  loadDomengPersistentMemory();
});
  }
}

function starPlayVoice(btn, text) {
      if (btn.dataset.playing === 'true') return;
      if (btn._audio) { btn._audio.play(); return; }

      const original = btn.textContent;
      btn.textContent = '⏳';
      btn.dataset.playing = 'true';

      fetch(DOMENG_CONFIG.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ action: 'speak', text: text })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data.success || !data.audio_base64) throw new Error('voice_failed');
          const audio = new Audio('data:audio/mpeg;base64,' + data.audio_base64);
          btn._audio = audio;
          btn.textContent = original;
          btn.dataset.playing = 'false';
          audio.play();
        })
        .catch(function () {
          btn.textContent = '⚠️';
          setTimeout(function () { btn.textContent = original; }, 2000);
          btn.dataset.playing = 'false';
        });
    }

    function addMessage(text, who, options = {}) {
      const msg = document.createElement("div");
      msg.className = `domeng-mfb__message domeng-mfb__message--${who}`;

      const bubble = document.createElement("div");
      bubble.className = "domeng-mfb__bubble";

      if (options.loading) {
        bubble.classList.add("domeng-mfb__bubble--loading");
      }

      if (who === "user") {
        bubble.textContent = text;
      } else {
        bubble.innerHTML = normalizeDomengHTML(text);
      }

      msg.appendChild(bubble);

      if (who !== "user" && !options.loading) {
        const voiceBtn = document.createElement("button");
        voiceBtn.type = "button";
        voiceBtn.textContent = "🔊";
        voiceBtn.style.cssText = "margin-top:6px;border:0;background:transparent;color:#7f5eb8;cursor:pointer;font-size:15px;";
        voiceBtn._speakText = String(text || "").replace(/<[^>]*>/g, " ");
        voiceBtn.addEventListener("click", function () {
          starPlayVoice(voiceBtn, voiceBtn._speakText);
        });
        msg.appendChild(voiceBtn);
      }

      if (Array.isArray(options.suggestions) && options.suggestions.length) {
        const suggestionsWrap = document.createElement("div");
        suggestionsWrap.className = "domeng-mfb__suggestions";
        suggestionsWrap.innerHTML = renderSuggestionCards(options.suggestions);
        msg.appendChild(suggestionsWrap);
      }

      body.appendChild(msg);
      body.scrollTop = body.scrollHeight;

      return msg;
    }

async function saveDomengLocalConversation(query, answer) {
  try {
    await fetch(DOMENG_CONFIG.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        action: "save_local_conversation",
        query: query,
        answer: answer,
        page: window.location.href,
        customerContext: getSafeCustomerContext(),
        productContext: getProduct(),
        conversationContext: {
          lastMood: DOMENG_SESSION.lastMood,
          lastCountry: DOMENG_SESSION.lastCountry,
          lastCategory: DOMENG_SESSION.lastCategory,
          lastBudget: DOMENG_SESSION.lastBudget,
          lastIntent: DOMENG_SESSION.lastIntent,
          recentMessages: DOMENG_SESSION.messages.slice(-6)
        }
      })
    });
  } catch (error) {
    console.warn("DOMENG local memory save failed:", error);
  }
}

    async function loadDomengPersistentMemory() {
  if (!memoryBox) return;

  try {
    const response = await fetch(DOMENG_CONFIG.endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        action: "load_memory",
        customerContext: getSafeCustomerContext(),
        page: window.location.href
      })
    });

    if (!response.ok) return;

    const data = await response.json();

    if (!data || !data.logged_in) {
      memoryBox.innerHTML = "";
      return;
    }

    DOMENG_PERSISTENT.loaded = true;
DOMENG_PERSISTENT.messages = Array.isArray(data.messages) ? data.messages : [];
DOMENG_PERSISTENT.memory = data.memory || {};

renderDomengPersistentMemory(data);
  } catch (error) {
    console.warn("DOMENG memory load failed:", error);
  }
}

function renderDomengPersistentMemory(data) {
  if (!memoryBox) return;

  const memory = data.memory || {};
  const messages = Array.isArray(data.messages) ? data.messages : [];

  const memoryParts = [];

  if (memory.favorite_mood && memory.favorite_mood.value) {
    memoryParts.push(`Favorite mood: ${escapeHtml(memory.favorite_mood.value)}`);
  }

  if (memory.preferred_category && memory.preferred_category.value) {
    memoryParts.push(`Preferred category: ${escapeHtml(memory.preferred_category.value)}`);
  }

  if (memory.shipping_country && memory.shipping_country.value) {
    memoryParts.push(`Shipping country: ${escapeHtml(memory.shipping_country.value)}`);
  }

  if (memory.ambassador_interest && memory.ambassador_interest.value === "yes") {
    memoryParts.push(`Ambassador interest: Yes`);
  }

  const recentLines = messages.slice(-8).map(function (msg) {
    const role = msg.role === "assistant" ? "Star" : "You";
    const text = truncateText(stripHtml(msg.message_text || ""), 90);

    return `<div class="domeng-mfb__memory-line"><b>${escapeHtml(role)}:</b> ${escapeHtml(text)}</div>`;
  }).join("");

  memoryBox.innerHTML = `
    <div class="domeng-mfb__memory-card">
      <strong>Previous shopping memory</strong>
      <span>${memoryParts.length ? memoryParts.join(" • ") : "I found previous conversations for this account."}</span>
      ${
        recentLines
          ? `<div class="domeng-mfb__memory-scroll">${recentLines}</div>`
          : `<span>No previous conversation lines yet.</span>`
      }
    </div>
  `;
}

    async function getDomengAnswer(query) {
      const payload = {
  query,
  page: window.location.href,
  customerContext: getSafeCustomerContext(),
  productContext: getProduct(),
  cartContext: null,
  frontendShippingCheck: buildShippingContext(query),
  conversationContext: {
    lastMood: DOMENG_SESSION.lastMood,
    lastCountry: DOMENG_SESSION.lastCountry,
    lastCategory: DOMENG_SESSION.lastCategory,
    lastBudget: DOMENG_SESSION.lastBudget,
    lastIntent: DOMENG_SESSION.lastIntent,
    recentMessages: DOMENG_SESSION.messages.slice(-6)
  },
  timestamp: new Date().toISOString()
};

      try {
        const response = await fetch(DOMENG_CONFIG.endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error("DOMENG backend unavailable");
        }

        const data = await response.json();

        return {
          answer: data.answer || fallbackAnswer(query),
          suggestions: Array.isArray(data.suggestions) ? data.suggestions : []
        };
      } catch (error) {
        return {
          answer: fallbackAnswer(query),
          suggestions: []
        };
      }
    }

    function detectDomengMood(query) {
  const q = normalizeText(query);

  for (const moodKey in DOMENG_MOOD_PROFILES) {
    const profile = DOMENG_MOOD_PROFILES[moodKey];

    if (!profile || !Array.isArray(profile.labels)) {
      continue;
    }

    for (const label of profile.labels) {
      if (q.includes(normalizeText(label))) {
        return {
          key: moodKey,
          profile
        };
      }
    }
  }

  return null;
}

function isMoodQuery(query) {
  return !!detectDomengMood(query);
}

function getMoodAnswer(query) {
  const mood = detectDomengMood(query);

  if (!mood || !mood.profile) {
    return "";
  }

  return mood.profile.answer;
}
function detectDomengIntent(query) {
  const q = normalizeText(query);

  if (q.includes("style quiz") || q.includes("find my style")) return "style_quiz";

  if (
    q.includes("caption") ||
    q.includes("instagram") ||
    q.includes("facebook post") ||
    q.includes("tiktok") ||
    q.includes("reel") ||
    q.includes("what should i post") ||
    q.includes("content")
  ) {
    return "content_help";
  }

  if (
    q.includes("ambassador") ||
    q.includes("affiliate") ||
    q.includes("earn") ||
    q.includes("commission") ||
    q.includes("creator") ||
    q.includes("influencer") ||
    q.includes("promote")
  ) {
    return "ambassador";
  }

  if (isShippingQuery(q)) return "shipping";

  if (q.includes("size") || q.includes("fit")) return "sizing";

  if (q.includes("track") || q.includes("order")) return "order";

  if (
    q.includes("complete the look") ||
    q.includes("pair") ||
    q.includes("match") ||
    q.includes("style this")
  ) {
    return "complete_look";
  }

  if (
    q.includes("find") ||
    q.includes("show") ||
    q.includes("suggest") ||
    q.includes("recommend") ||
    q.includes("shop") ||
    q.includes("dress") ||
q.includes("bag") ||
q.includes("top") ||
q.includes("shoe") ||
q.includes("shoes") ||
q.includes("sneaker") ||
q.includes("sneakers") ||
q.includes("footwear") ||
q.includes("outfit") ||
q.includes("look") ||
q.includes("mood")
  ) {
    return "product_discovery";
  }

  return "general";
}

function detectCategory(query) {
  const q = normalizeText(query);

  if (q.includes("dress") || q.includes("dresses")) return "dress";
if (q.includes("bag") || q.includes("bags") || q.includes("tote")) return "bag";
if (q.includes("top") || q.includes("blouse") || q.includes("shirt")) return "top";
if (q.includes("skirt")) return "skirt";
if (q.includes("shoe") || q.includes("shoes") || q.includes("sneaker") || q.includes("sneakers") || q.includes("footwear")) return "shoes";
if (q.includes("jewelry") || q.includes("accessories")) return "accessories";
if (q.includes("loungewear") || q.includes("bra") || q.includes("intimates")) return "loungewear";

  return null;
}

function detectAudience(query) {
  const q = normalizeDomengSearchText(query);

  if (
    q.includes("i m a man") ||
    q.includes("i am a man") ||
    q.includes("male shopper") ||
    q.includes("for men") ||
    q.includes("men s") ||
    domengHasWholeTerm(q, "man") ||
    domengHasWholeTerm(q, "male") ||
    domengHasWholeTerm(q, "men") ||
    domengHasWholeTerm(q, "mens")
  ) {
    return "mens";
  }

  if (
    q.includes("i m a woman") ||
    q.includes("i am a woman") ||
    q.includes("female shopper") ||
    q.includes("for women") ||
    q.includes("women s") ||
    domengHasWholeTerm(q, "woman") ||
    domengHasWholeTerm(q, "female") ||
    domengHasWholeTerm(q, "women") ||
    domengHasWholeTerm(q, "womens")
  ) {
    return "womens";
  }

  return null;
}

function getDomengRequestedAudience(query) {
  const explicitAudience = detectAudience(query);

  if (explicitAudience) {
    return explicitAudience;
  }

  const q = normalizeDomengSearchText(query);
  const product = getProduct();

  const shouldUseCurrentProductAudience =
    q.includes("match") ||
    q.includes("pair") ||
    q.includes("complete") ||
    q.includes("like this") ||
    q.includes("similar") ||
    q.includes("this") ||
    q.includes("my shoes") ||
    q.includes("my shirt") ||
    q.includes("my bag");

  if (product && shouldUseCurrentProductAudience) {
    const productText = normalizeDomengSearchText([
      product.title,
      product.description,
      product.product_type,
      product.type,
      product.vendor,
      Array.isArray(product.tags) ? product.tags.join(" ") : ""
    ].join(" "));

    if (
      productText.includes("men s") ||
      domengHasWholeTerm(productText, "men") ||
      domengHasWholeTerm(productText, "mens") ||
      domengHasWholeTerm(productText, "male")
    ) {
      return "mens";
    }

    if (
      productText.includes("women s") ||
      domengHasWholeTerm(productText, "women") ||
      domengHasWholeTerm(productText, "womens") ||
      domengHasWholeTerm(productText, "female")
    ) {
      return "womens";
    }
  }

  return DOMENG_SESSION.lastAudience || "";
}

function detectBudget(query) {
  const q = normalizeText(query);

  if (
    q.includes("no budget") ||
    q.includes("any price") ||
    q.includes("premium") ||
    q.includes("luxury") ||
    q.includes("best one")
  ) {
    return "no budget limit";
  }

  const directBudgetMatch = q.match(
    /(?:under|below|less than|max|maximum|up to)\s*\$?\s*(\d{2,5})/
  );

  if (directBudgetMatch && directBudgetMatch[1]) {
    return `under $${Number(directBudgetMatch[1])}`;
  }

  const reverseBudgetMatch = q.match(
    /\$?\s*(\d{2,5})\s*(?:or less|and below|max|maximum)/
  );

  if (reverseBudgetMatch && reverseBudgetMatch[1]) {
    return `under $${Number(reverseBudgetMatch[1])}`;
  }

  if (q.includes("under 50") || q.includes("below 50") || q.includes("$50")) {
    return "under $50";
  }

  if (q.includes("under 100") || q.includes("below 100") || q.includes("$100")) {
    return "under $100";
  }

  if (q.includes("under 150") || q.includes("below 150") || q.includes("$150")) {
    return "under $150";
  }

  return null;
}

function updateDomengSession(query) {
  const mood = detectDomengMood(query);
  const country = detectCountry(query);
  const category = detectCategory(query);
  const budget = detectBudget(query);
  const audience = detectAudience(query);
  const intent = detectDomengIntent(query);

  if (mood && mood.key) DOMENG_SESSION.lastMood = mood.key;
  if (country) DOMENG_SESSION.lastCountry = country;
  if (category) DOMENG_SESSION.lastCategory = category;
  if (budget) DOMENG_SESSION.lastBudget = budget;
  if (audience) DOMENG_SESSION.lastAudience = audience;
  if (intent) DOMENG_SESSION.lastIntent = intent;

  DOMENG_SESSION.messages.push({
    role: "user",
    text: String(query || ""),
    intent,
    mood: mood ? mood.key : null,
    country,
    category,
    budget,
    audience,
    time: new Date().toISOString()
  });

  if (DOMENG_SESSION.messages.length > 12) {
    DOMENG_SESSION.messages = DOMENG_SESSION.messages.slice(-12);
  }
}

function getSessionStyleSummary() {
  const parts = [];

  if (DOMENG_SESSION.lastMood) {
    const mood = DOMENG_MOOD_PROFILES[DOMENG_SESSION.lastMood];
    if (mood && mood.labels && mood.labels[0]) {
      parts.push(`mood: ${mood.labels[0]}`);
    }
  }

  if (DOMENG_SESSION.lastCategory) {
    parts.push(`category: ${DOMENG_SESSION.lastCategory}`);
  }

  if (DOMENG_SESSION.lastCountry) {
    parts.push(`country: ${DOMENG_SESSION.lastCountry}`);
  }

  if (DOMENG_SESSION.lastBudget) {
    parts.push(`budget: ${DOMENG_SESSION.lastBudget}`);
  }

  return parts.length ? parts.join(", ") : "";
}

function getConversationalBridge(query) {
  const summary = getSessionStyleSummary();

  if (!summary) {
    return "";
  }

  return `Based on what you have shared so far (${summary}), `;
}

    function isProductSuggestionQuery(query) {
  const q = String(query || "").toLowerCase();

  if (isMoodQuery(query)) {
    return true;
  }

  const nonProductIntent = [
    "track",
    "order status",
    "shipping",
    "ship",
    "refund",
    "return",
    "contact",
    "support",
    "affiliate",
    "ambassador",
    "commission",
    "login",
    "account",
    "sign in",
    "create account"
  ];

  if (nonProductIntent.some(word => q.includes(word))) {
    return false;
  }

  return /(find|show|suggest|recommend|shop|dress|dresses|bag|bags|tote|top|tops|shirt|shirts|blouse|skirt|skirts|shoe|shoes|sneaker|sneakers|footwear|jewelry|gift|jeans|denim|pants|trousers|shorts|mens|men|women|lavender|black|white|gold|outfit|look|style|mood|vibe|aesthetic|brunch|vacation|travel|date night|office|workwear|minimalist|feminine|power woman|boss|luxe casual|clean girl|quiet luxury|accessories|fashion|similar|complete the look)/.test(q);
}

    async function fetchProductSuggestions(query, limit = 4) {
  try {
    const searchTerms = buildProductSearchTerms(query);
    const currentProduct = getProduct();
    const requestedAudience = getDomengRequestedAudience(query);
    const currentProductPath = currentProduct && currentProduct.url
      ? normalizeDomengProductUrl(currentProduct.url)
      : window.location.pathname;

    let finalItems = [];
    const seenUrls = new Set();

    for (const term of searchTerms) {
      const suggestUrl =
        `${window.location.origin}/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`;

      const response = await fetch(suggestUrl, {
        method: "GET",
        credentials: "same-origin"
      });

      if (!response.ok) continue;

      const data = await response.json();
      const products = data?.resources?.results?.products || [];

      if (!products.length) continue;

      const items = await Promise.all(
        products.slice(0, 8).map(async (item) => {
          const productPath = item.url
            ? new URL(item.url, window.location.origin).pathname
            : "";

          let details = {};

          if (productPath) {
            try {
              const detailResponse = await fetch(`${productPath}.js`, {
                method: "GET",
                credentials: "same-origin"
              });

              if (detailResponse.ok) {
                details = await detailResponse.json();
              }
            } catch (e) {}
          }

          const rawImage =
            item.featured_image?.url ||
            item.image ||
            details.featured_image ||
            (Array.isArray(details.images) ? details.images[0] : "");

          const image = rawImage
            ? String(rawImage).replace(/^\/\//, "https://")
            : "";

          const descriptionSource =
            details.description ||
            item.body ||
            item.summary ||
            item.content ||
            details.product_type ||
            item.product_type ||
            "A curated Michelle Francisco Beauty pick.";

          const rawPrice =
            details.price ??
            item.price ??
            item.price_min ??
            item.min_price ??
            null;

          const firstAvailableVariant =
  Array.isArray(details.variants)
    ? details.variants.find(function (variant) {
        return variant && variant.available;
      }) || details.variants[0]
    : null;

return {
  title: item.title || details.title || "Suggested Item",
  url: productPath || item.url || "#",
  image,
  description: truncateText(stripHtml(descriptionSource), 105),
  price: formatMoney(rawPrice),
  priceValue: normalizeDomengPriceNumber(rawPrice),
  variantId:
    firstAvailableVariant && firstAvailableVariant.id
      ? firstAvailableVariant.id
      : item.variant_id || item.variantId || "",
  product_type:
    details.product_type ||
    details.type ||
    item.product_type ||
    item.type ||
    "",
  vendor:
    details.vendor ||
    item.vendor ||
    "",
  tags:
    Array.isArray(details.tags)
      ? details.tags.join(" ")
      : Array.isArray(item.tags)
        ? item.tags.join(" ")
        : ""
};
        })
      );

      const relevantItems = items.filter(function (item) {
        const itemUrl = normalizeDomengProductUrl(item.url);

        if (!itemUrl || itemUrl === "#") {
          return false;
        }

        if (
          currentProductPath &&
          itemUrl &&
          itemUrl.replace(/\/$/, "") === currentProductPath.replace(/\/$/, "")
        ) {
          return false;
        }

        if (seenUrls.has(itemUrl)) {
          return false;
        }

        return isRelevantDomengProduct(item, query);
      });

      relevantItems.forEach(function (item) {
        const itemUrl = normalizeDomengProductUrl(item.url);
        seenUrls.add(itemUrl);
        finalItems.push(item);
      });

      if (finalItems.length >= limit) {
        break;
      }
    }

    return finalItems.slice(0, limit);
  } catch (error) {
    console.error("DOMENG product suggestion search failed:", error);
    return [];
  }
}

const DOMENG_STOPWORDS = new Set([
  "the","a","an","is","are","was","were","do","does","did","i","you","your","yours","me","my","we","our",
  "for","to","of","in","on","at","with","and","or","but","what","which","who","whom","this","that","these","those",
  "show","find","give","tell","want","looking","look","have","has","had","can","could","would","should","will",
  "please","some","any","new","best","good","great","nice","something","anything","one","ones","get","got"
]);

function extractDomengQueryTerms(query) {
  const cleaned = normalizeDomengSearchText(query);
  const words = cleaned.split(" ").filter(Boolean);
  const terms = words.filter(function (word) {
    return word.length > 2 && !DOMENG_STOPWORDS.has(word);
  });
  return [...new Set(terms)];
}

const DOMENG_SITE_INDEX_KEY = "mfb_domeng_site_index_v1";
const DOMENG_SITE_INDEX_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

async function buildDomengSiteIndex() {
  const pages = [];

  try {
    const sitemapResponse = await fetch("/sitemap.xml", { credentials: "same-origin" });
    if (!sitemapResponse.ok) return pages;

    const sitemapText = await sitemapResponse.text();
    const sitemapDoc = new DOMParser().parseFromString(sitemapText, "text/xml");

    let sitemapUrls = Array.from(sitemapDoc.querySelectorAll("sitemap loc")).map(function (node) {
      return node.textContent.trim();
    });

    if (!sitemapUrls.length) {
      const directLocs = Array.from(sitemapDoc.querySelectorAll("url loc")).map(function (node) {
        return node.textContent.trim();
      });
      sitemapUrls = directLocs.length ? ["__direct__"] : [];
      if (directLocs.length) {
        directLocs.forEach(function (url) { pages.push({ url }); });
      }
    } else {
      const pageSitemaps = sitemapUrls.filter(function (url) {
        return url.includes("sitemap_pages") || url.includes("pages_") || url.includes("/pages");
      });

      const sitemapsToScan = (pageSitemaps.length ? pageSitemaps : sitemapUrls).slice(0, 3);

      for (const subSitemapUrl of sitemapsToScan) {
        try {
          const subResponse = await fetch(subSitemapUrl, { credentials: "same-origin" });
          if (!subResponse.ok) continue;
          const subText = await subResponse.text();
          const subDoc = new DOMParser().parseFromString(subText, "text/xml");
          const locs = Array.from(subDoc.querySelectorAll("url loc")).map(function (node) {
            return node.textContent.trim();
          });
          locs.forEach(function (url) { pages.push({ url }); });
        } catch (e) {}
      }
    }
  } catch (error) {
    console.warn("STAR site index: sitemap fetch failed", error);
    return [];
  }

  const homepageUrl = window.location.origin + "/";
  if (!pages.some(function (p) { return p.url === homepageUrl; })) {
    pages.unshift({ url: homepageUrl });
  }

  const candidatePages = pages
    .filter(function (p) {
      return !p.url.includes("/products/") && !p.url.includes("/collections/") && !p.url.includes("/blogs/");
    })
    .slice(0, 25);

  const indexed = [];

  for (const page of candidatePages) {
    try {
      const pageResponse = await fetch(page.url, { credentials: "same-origin" });
      if (!pageResponse.ok) continue;

      const html = await pageResponse.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      doc.querySelectorAll("script, style, nav, header, footer, .domeng-mfb").forEach(function (el) {
        el.remove();
      });

      const title = doc.querySelector("title") ? doc.querySelector("title").textContent.trim() : page.url;
      const bodyText = doc.body ? doc.body.textContent : "";
      const cleanText = normalizeDomengSearchText(bodyText).slice(0, 4000);

      if (cleanText.length > 40) {
        indexed.push({ url: page.url, title: title, text: cleanText });
      }
    } catch (e) {}
  }

  return indexed;
}

async function getDomengSiteIndex() {
  try {
    const cachedRaw = localStorage.getItem(DOMENG_SITE_INDEX_KEY);
    if (cachedRaw) {
      const cached = JSON.parse(cachedRaw);
      if (cached && cached.timestamp && (Date.now() - cached.timestamp) < DOMENG_SITE_INDEX_TTL_MS) {
        return cached.pages || [];
      }
    }
  } catch (e) {}

  const freshIndex = await buildDomengSiteIndex();

  try {
    localStorage.setItem(DOMENG_SITE_INDEX_KEY, JSON.stringify({
      timestamp: Date.now(),
      pages: freshIndex
    }));
  } catch (e) {}

  return freshIndex;
}

async function searchDomengSiteContent(query) {
  const queryTerms = extractDomengQueryTerms(query);
  if (!queryTerms.length) return null;

  const pages = await getDomengSiteIndex();
  if (!pages.length) return null;

  let bestPage = null;
  let bestScore = 0;

  pages.forEach(function (page) {
    let score = 0;
    const titleText = normalizeDomengSearchText(page.title || "");

    queryTerms.forEach(function (term) {
      if (domengHasWholeTerm(titleText, term)) score += 15;

      const regex = new RegExp("\\b" + term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\b", "gi");
      const matches = page.text.match(regex);
      if (matches) score += matches.length * 2;
    });

    if (score > bestScore) {
      bestScore = score;
      bestPage = page;
    }
  });

  if (!bestPage || bestScore < 6) return null;

  const snippetTerm = queryTerms[0];
  const lowerText = bestPage.text;
  const idx = lowerText.indexOf(snippetTerm);
  const snippetStart = Math.max(0, idx - 120);
  const snippet = bestPage.text.slice(snippetStart, snippetStart + 320);

  return {
    url: bestPage.url,
    title: bestPage.title,
    snippet: snippet
  };
}

async function fetchDomengGenericProductMatch(query, limit = 4) {
  try {
    const queryTerms = extractDomengQueryTerms(query);
    if (!queryTerms.length) return [];

    const requestedAudience = getDomengRequestedAudience(query);
    const scored = [];
    const seenHandles = new Set();

    for (let page = 1; page <= 15; page++) {
      const response = await fetch(`/products.json?limit=250&page=${page}`, {
        method: "GET",
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      });

      if (!response.ok) break;

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];
      if (!products.length) break;

      products.forEach(function (product) {
        if (!product.handle || seenHandles.has(product.handle)) return;

        const titleText = normalizeDomengSearchText(product.title || "");
        const typeText = normalizeDomengSearchText(product.product_type || "");
        const descText = normalizeDomengSearchText(stripHtml(product.body_html || ""));
        const tagsText = normalizeDomengSearchText(
          Array.isArray(product.tags) ? product.tags.join(" ") : String(product.tags || "")
        );

        let score = 0;

        queryTerms.forEach(function (term) {
          if (domengHasWholeTerm(titleText, term)) score += 30;
          if (domengHasWholeTerm(typeText, term)) score += 20;
          if (domengHasWholeTerm(tagsText, term)) score += 12;
          if (domengHasWholeTerm(descText, term)) score += 6;
        });

        if (score <= 0) return;

        const combinedText = titleText + " " + typeText + " " + descText + " " + tagsText;
        const isMensProduct =
          combinedText.includes("men s") ||
          domengHasWholeTerm(combinedText, "men") ||
          domengHasWholeTerm(combinedText, "mens") ||
          domengHasWholeTerm(combinedText, "male");
        const isWomensProduct =
          combinedText.includes("women s") ||
          domengHasWholeTerm(combinedText, "women") ||
          domengHasWholeTerm(combinedText, "womens") ||
          domengHasWholeTerm(combinedText, "female");

        if (requestedAudience === "mens" && isWomensProduct && !isMensProduct) return;
        if (requestedAudience === "womens" && isMensProduct && !isWomensProduct) return;

        const firstAvailableVariant = Array.isArray(product.variants)
          ? product.variants.find(function (v) { return v && v.available !== false; }) || product.variants[0]
          : null;

        if (!firstAvailableVariant) return;

        const rawImage =
          product.image && product.image.src
            ? product.image.src
            : Array.isArray(product.images) && product.images[0]
              ? product.images[0].src
              : "";

        const rawPrice = firstAvailableVariant.price || "";

        seenHandles.add(product.handle);

        scored.push({
          title: product.title || "Suggested Item",
          url: `/products/${product.handle}`,
          image: normalizeDomengImageUrl(rawImage),
          description: truncateText(stripHtml(product.body_html || "A curated Michelle Francisco Beauty piece."), 105),
          price: rawPrice ? formatMoney(Number(rawPrice) * 100) : "",
          priceValue: rawPrice ? Number(rawPrice) : null,
          variantId: firstAvailableVariant.id || "",
          product_type: product.product_type || "",
          vendor: product.vendor || "",
          tags: Array.isArray(product.tags) ? product.tags.join(" ") : String(product.tags || ""),
          domengScore: score
        });
      });

      if (scored.length >= limit * 3) break;
    }

    return scored
      .sort(function (a, b) { return b.domengScore - a.domengScore; })
      .slice(0, limit);
  } catch (error) {
    console.error("STAR generic product match failed:", error);
    return [];
  }
}

async function fetchSimilarProductSuggestions(query, limit = 4) {
  try {
    const currentProduct = getProduct();

    if (!currentProduct || !currentProduct.title) {
      return [];
    }

    const currentProductPath = currentProduct.url
      ? normalizeDomengProductUrl(currentProduct.url)
      : window.location.pathname;

    const productText = normalizeDomengSearchText([
      currentProduct.title,
      currentProduct.product_type,
      currentProduct.type,
      currentProduct.description,
      Array.isArray(currentProduct.tags) ? currentProduct.tags.join(" ") : ""
    ].join(" "));

    const terms = [];

    if (currentProduct.product_type) {
      terms.push(currentProduct.product_type);
      terms.push(normalizeDomengSearchText(currentProduct.product_type));
    }

    if (currentProduct.type) {
      terms.push(currentProduct.type);
      terms.push(normalizeDomengSearchText(currentProduct.type));
    }

    if (
      productPageHas(productText, "shirt") ||
      productPageHas(productText, "button shirt") ||
      productPageHas(productText, "button")
    ) {
      terms.push(
        "shirt",
        "shirts",
        "button shirt",
        "mens shirt",
        "men shirt",
        "men's shirt",
        "button shirts",
        "top"
      );
    }

    if (productPageHas(productText, "eggplant")) {
      terms.push("eggplant shirt", "eggplant", "purple shirt", "plum shirt");
    }

    if (productPageHas(productText, "purple")) {
      terms.push("purple shirt", "purple", "plum");
    }

    if (productPageHas(productText, "dress")) {
      terms.push("dress", "dresses", "midi dress", "mini dress", "maxi dress");
    }

    if (
      productPageHas(productText, "shoe") ||
      productPageHas(productText, "shoes") ||
      productPageHas(productText, "athletic shoes")
    ) {
      terms.push("shoes", "athletic shoes", "sneakers", "footwear");
    }

    if (
      productPageHas(productText, "bag") ||
      productPageHas(productText, "tote") ||
      productPageHas(productText, "handbag")
    ) {
      terms.push("bag", "tote", "handbag");
    }

    if (currentProduct.title) {
      terms.push(normalizeDomengSearchText(currentProduct.title));
    }

    terms.push("shirt", "top", "mens shirt", "button shirt");

    const cleanTerms = [...new Set(terms)].filter(Boolean).slice(0, 16);
    const seenUrls = new Set();
    const finalItems = [];

    for (const term of cleanTerms) {
      const suggestUrl =
        `${window.location.origin}/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide`;

      const response = await fetch(suggestUrl, {
        method: "GET",
        credentials: "same-origin"
      });

      if (!response.ok) continue;

      const data = await response.json();
      const products = data?.resources?.results?.products || [];

      if (!products.length) continue;

      const items = await Promise.all(
        products.slice(0, 10).map(async function (item) {
          const productPath = item.url
            ? new URL(item.url, window.location.origin).pathname
            : "";

          let details = {};

          if (productPath) {
            try {
              const detailResponse = await fetch(`${productPath}.js`, {
                method: "GET",
                credentials: "same-origin"
              });

              if (detailResponse.ok) {
                details = await detailResponse.json();
              }
            } catch (e) {}
          }

          const rawImage =
            item.featured_image?.url ||
            item.image ||
            details.featured_image ||
            (Array.isArray(details.images) ? details.images[0] : "");

          const image = rawImage
            ? String(rawImage).replace(/^\/\//, "https://")
            : "";

          const descriptionSource =
            details.description ||
            item.body ||
            item.summary ||
            item.content ||
            details.product_type ||
            item.product_type ||
            "A curated Michelle Francisco Beauty pick.";

          const rawPrice =
            details.price ??
            item.price ??
            item.price_min ??
            item.min_price ??
            null;

          const firstAvailableVariant =
  Array.isArray(details.variants)
    ? details.variants.find(function (variant) {
        return variant && variant.available;
      }) || details.variants[0]
    : null;

return {
  title: item.title || details.title || "Suggested Item",
  url: productPath || item.url || "#",
  image,
  description: truncateText(stripHtml(descriptionSource), 105),
  price: formatMoney(rawPrice),
  priceValue: normalizeDomengPriceNumber(rawPrice),
  variantId:
    firstAvailableVariant && firstAvailableVariant.id
      ? firstAvailableVariant.id
      : item.variant_id || item.variantId || "",
  product_type:
    details.product_type ||
    details.type ||
    item.product_type ||
    item.type ||
    "",
  vendor:
    details.vendor ||
    item.vendor ||
    "",
  tags:
    Array.isArray(details.tags)
      ? details.tags.join(" ")
      : Array.isArray(item.tags)
        ? item.tags.join(" ")
        : ""
};
        })
      );

      const filtered = items.filter(function (item) {
        const itemUrl = normalizeDomengProductUrl(item.url);

        if (!itemUrl || itemUrl === "#") {
          return false;
        }

        if (
          currentProductPath &&
          itemUrl.replace(/\/$/, "") === currentProductPath.replace(/\/$/, "")
        ) {
          return false;
        }

        if (seenUrls.has(itemUrl)) {
          return false;
        }

        const itemText = normalizeDomengSearchText([
          item.title,
          item.description,
          item.product_type,
          item.type,
          item.tags
        ].join(" "));

        const sameKind =
          productPageHas(productText, "shirt")
            ? (
                productPageHas(itemText, "shirt") ||
                productPageHas(itemText, "button shirt") ||
                productPageHas(itemText, "top")
              )
            : true;

        return sameKind;
      });

      filtered.forEach(function (item) {
        const itemUrl = normalizeDomengProductUrl(item.url);
        seenUrls.add(itemUrl);
        finalItems.push(item);
      });

      if (finalItems.length >= limit) {
        break;
      }
    }

    return filterDomengProductsByBudget(finalItems, query).slice(0, limit);
  } catch (error) {
    console.error("DOMENG similar product search failed:", error);
    return [];
  }
}

function getBudgetLimitValue(query) {
  const budget = detectBudget(query);

  if (!budget || budget === "no budget limit") {
    return null;
  }

  const match = String(budget).match(/\$?\s*(\d{2,5})/);

  return match && match[1] ? Number(match[1]) : null;
}

function normalizeDomengPriceNumber(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  let amount = value;

  if (typeof amount === "string") {
    amount = amount
      .replace(/USD/gi, "")
      .replace(/\$/g, "")
      .replace(/,/g, "")
      .trim();
  }

  amount = Number(amount);

  if (Number.isNaN(amount)) {
    return null;
  }

  /*
    Shopify .js prices often come in cents.
    Example: 4999 means $49.99.
  */
  if (amount > 999) {
    amount = amount / 100;
  }

  return amount;
}

function filterDomengProductsByBudget(items, query) {
  const budgetLimit = getBudgetLimitValue(query);

  if (!budgetLimit || !Array.isArray(items) || !items.length) {
    return items;
  }

  return items.filter(function (item) {
    const priceNumber =
      item.priceValue !== null && item.priceValue !== undefined
        ? Number(item.priceValue)
        : normalizeDomengPriceNumber(item.price);

    return priceNumber !== null && !Number.isNaN(priceNumber) && priceNumber <= budgetLimit;
  });
}

function getRequiredProductTerms(query) {
  const q = normalizeDomengSearchText(query);

  /*
    Priority rule:
    When the shopper says "tops to match my shoes",
    the requested category is TOPS, not shoes.
  */

  if (
    domengHasWholeTerm(q, "top") ||
    domengHasWholeTerm(q, "tops") ||
    domengHasWholeTerm(q, "blouse") ||
    domengHasWholeTerm(q, "shirt") ||
    domengHasWholeTerm(q, "shirts") ||
    domengHasWholeTerm(q, "tee") ||
    domengHasWholeTerm(q, "tank")
  ) {
    return ["top", "tops", "blouse", "shirt", "shirts", "tee", "tank", "button shirt"];
  }

  if (domengHasWholeTerm(q, "dress") || domengHasWholeTerm(q, "dresses")) {
    return ["dress", "dresses", "gown"];
  }

  if (
    domengHasWholeTerm(q, "bag") ||
    domengHasWholeTerm(q, "bags") ||
    domengHasWholeTerm(q, "tote") ||
    domengHasWholeTerm(q, "handbag") ||
    domengHasWholeTerm(q, "purse")
  ) {
    return ["bag", "bags", "tote", "handbag", "purse"];
  }

  if (domengHasWholeTerm(q, "skirt") || domengHasWholeTerm(q, "skirts")) {
    return ["skirt", "skirts"];
  }

  if (
    domengHasWholeTerm(q, "jeans") ||
    domengHasWholeTerm(q, "denim") ||
    domengHasWholeTerm(q, "pants") ||
    domengHasWholeTerm(q, "trousers") ||
    domengHasWholeTerm(q, "bottom") ||
    domengHasWholeTerm(q, "bottoms")
  ) {
    return ["jeans", "denim", "pants", "trousers", "bottom", "bottoms"];
  }

  if (
    domengHasWholeTerm(q, "accessory") ||
    domengHasWholeTerm(q, "accessories") ||
    domengHasWholeTerm(q, "jewelry") ||
    domengHasWholeTerm(q, "necklace") ||
    domengHasWholeTerm(q, "bracelet") ||
    domengHasWholeTerm(q, "earrings")
  ) {
    return ["accessory", "accessories", "jewelry", "necklace", "bracelet", "earrings"];
  }

  if (
    domengHasWholeTerm(q, "shoe") ||
    domengHasWholeTerm(q, "shoes") ||
    domengHasWholeTerm(q, "sneaker") ||
    domengHasWholeTerm(q, "sneakers") ||
    domengHasWholeTerm(q, "footwear") ||
    domengHasWholeTerm(q, "heel") ||
    domengHasWholeTerm(q, "heels") ||
    domengHasWholeTerm(q, "sandal") ||
    domengHasWholeTerm(q, "sandals") ||
    domengHasWholeTerm(q, "boot") ||
    domengHasWholeTerm(q, "boots") ||
    domengHasWholeTerm(q, "pump") ||
    domengHasWholeTerm(q, "pumps") ||
    domengHasWholeTerm(q, "slipper") ||
    domengHasWholeTerm(q, "slippers") ||
    domengHasWholeTerm(q, "athletic shoes") ||
    domengHasWholeTerm(q, "canvas shoes")
  ) {
    return [
      "shoe",
      "shoes",
      "sneaker",
      "sneakers",
      "footwear",
      "heel",
      "heels",
      "sandal",
      "sandals",
      "boot",
      "boots",
      "pump",
      "pumps",
      "slipper",
      "slippers",
      "athletic shoes",
      "canvas shoes",
      "slip on canvas shoes",
      "slipon canvas shoes",
      "mens athletic shoes",
      "men athletic shoes",
      "mens slipon canvas shoes",
      "men slipon canvas shoes"
    ];
  }

  return [];
}

function hasStrictProductRequirement(query) {
  return getRequiredProductTerms(query).length > 0;
}

function normalizeDomengSearchText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[-_/]+/g, " ")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function domengHasWholeTerm(haystack, term) {
  const cleanHaystack = normalizeDomengSearchText(haystack);
  const cleanTerm = normalizeDomengSearchText(term);

  if (!cleanTerm) {
    return false;
  }

  const pattern = new RegExp("\\b" + cleanTerm.replace(/\s+/g, "\\s+") + "\\b", "i");

  return pattern.test(cleanHaystack);
}

function isRelevantDomengProduct(item, query) {
  const requiredTerms = getRequiredProductTerms(query);

  if (!requiredTerms.length) {
    return true;
  }

  const haystack = normalizeDomengSearchText([
    item.title,
    item.description,
    item.product_type,
    item.type,
    item.vendor,
    item.tags
  ].join(" "));

  const requestedAudience = getDomengRequestedAudience(query);

  const isMensProduct =
    haystack.includes("men s") ||
    domengHasWholeTerm(haystack, "men") ||
    domengHasWholeTerm(haystack, "mens") ||
    domengHasWholeTerm(haystack, "male");

  const isWomensProduct =
    haystack.includes("women s") ||
    domengHasWholeTerm(haystack, "women") ||
    domengHasWholeTerm(haystack, "womens") ||
    domengHasWholeTerm(haystack, "female");

  if (requestedAudience === "mens") {
    if (isWomensProduct) {
      return false;
    }

    if (!isMensProduct) {
      return false;
    }
  }

  if (requestedAudience === "womens") {
    if (isMensProduct) {
      return false;
    }

    if (!isWomensProduct) {
      return false;
    }
  }

  const shoeTerms = [
    "shoe",
    "shoes",
    "sneaker",
    "sneakers",
    "footwear",
    "heel",
    "heels",
    "sandal",
    "sandals",
    "boot",
    "boots",
    "pump",
    "pumps",
    "slipper",
    "slippers",
    "athletic shoes",
    "canvas shoes",
    "slip on canvas shoes",
    "slipon canvas shoes",
    "mens athletic shoes",
    "men athletic shoes",
    "mens slipon canvas shoes",
    "men slipon canvas shoes"
  ];

  const requestedShoes = requiredTerms.some(function (term) {
    return shoeTerms.some(function (shoeTerm) {
      return normalizeDomengSearchText(term) === normalizeDomengSearchText(shoeTerm);
    });
  });

  if (requestedShoes) {
    return shoeTerms.some(function (term) {
      return domengHasWholeTerm(haystack, term);
    });
  }

  return requiredTerms.some(function (term) {
    return domengHasWholeTerm(haystack, term);
  });
}
function buildProductSearchTerms(query) {
  const q = String(query || "").toLowerCase();
  const terms = [];
  const savedMemory = DOMENG_PERSISTENT.memory || {};
  const currentProduct = getProduct();

if (
  currentProduct &&
  (
    q.includes("similar") ||
    q.includes("like this") ||
    q.includes("something like this") ||
    q.includes("more like this") ||
    q.includes("same style") ||
    q.includes("same type")
  )
) {
  const productText = normalizeDomengSearchText([
    currentProduct.title,
    currentProduct.product_type,
    currentProduct.type,
    currentProduct.description,
    Array.isArray(currentProduct.tags) ? currentProduct.tags.join(" ") : ""
  ].join(" "));

  if (currentProduct.product_type) {
    terms.push(currentProduct.product_type);
    terms.push(normalizeDomengSearchText(currentProduct.product_type));
  }

  if (currentProduct.type) {
    terms.push(currentProduct.type);
    terms.push(normalizeDomengSearchText(currentProduct.type));
  }

  if (productPageHas(productText, "shirt") || productPageHas(productText, "button shirt")) {
    terms.push("shirt", "button shirt", "mens shirt", "men shirt", "top");
  }

  if (productPageHas(productText, "dress")) {
    terms.push("dress", "midi dress", "mini dress", "maxi dress");
  }

  if (productPageHas(productText, "shoe") || productPageHas(productText, "shoes") || productPageHas(productText, "athletic shoes")) {
    terms.push("shoes", "athletic shoes", "sneakers", "footwear");
  }

  if (productPageHas(productText, "canvas shoes") || productPageHas(productText, "slipon canvas shoes")) {
    terms.push("canvas shoes", "slip on canvas shoes", "slipon canvas shoes");
  }

  if (productPageHas(productText, "bag") || productPageHas(productText, "tote") || productPageHas(productText, "handbag")) {
    terms.push("bag", "tote", "handbag");
  }

  if (productPageHas(productText, "purple") || productPageHas(productText, "eggplant")) {
    terms.push("purple", "eggplant", "plum");
  }

  if (productPageHas(productText, "black")) {
    terms.push("black");
  }

  if (productPageHas(productText, "white")) {
    terms.push("white");
  }

  if (productPageHas(productText, "red")) {
    terms.push("red");
  }

  if (productPageHas(productText, "pink")) {
    terms.push("pink");
  }

  if (currentProduct.title) {
    const cleanedTitle = normalizeDomengSearchText(currentProduct.title)
      .replace(/\bmen s\b/g, "mens")
      .replace(/\bwomen s\b/g, "womens")
      .replace(/\bshirt\b/g, "shirt")
      .trim();

    terms.push(cleanedTitle);
  }
}

if (
  q.includes("previous") ||
  q.includes("memory") ||
  q.includes("remember") ||
  q.includes("based on my")
) {
  if (savedMemory.favorite_mood && savedMemory.favorite_mood.value) {
    const savedMoodKey = savedMemory.favorite_mood.value;
    const savedMood = DOMENG_MOOD_PROFILES[savedMoodKey];

    if (savedMood && Array.isArray(savedMood.searchTerms)) {
      savedMood.searchTerms.forEach(term => terms.push(term));
    }
  }

  if (savedMemory.preferred_category && savedMemory.preferred_category.value) {
    const savedCategory = savedMemory.preferred_category.value;

    if (savedCategory === "dress") terms.push("dress", "floral dress", "midi dress", "mini dress");
    if (savedCategory === "bag") terms.push("bag", "tote", "handbag");
    if (savedCategory === "top") terms.push("top", "blouse", "shirt");
    if (savedCategory === "shoes") terms.push("shoes", "sneakers");
    if (savedCategory === "jeans_denim") terms.push("jeans", "denim", "pants");
  }
}

  const mood = detectDomengMood(query);

  if (mood && mood.profile && Array.isArray(mood.profile.searchTerms)) {
    mood.profile.searchTerms.forEach(term => terms.push(term));
  }

  if (q.includes("jeans") || q.includes("denim") || q.includes("pants") || q.includes("trousers")) {
  terms.push("jeans", "denim", "denim jeans", "pants", "trousers");
  }

  if (q.includes("dress") || q.includes("dresses")) {
    terms.push("dress", "maxi dress", "midi dress", "mini dress", "floral dress");
  }

  if (q.includes("bag") || q.includes("bags") || q.includes("tote")) {
    terms.push("bag", "tote", "handbag");
  }

  if (
  q.includes("top") ||
  q.includes("tops") ||
  q.includes("blouse") ||
  q.includes("shirt") ||
  q.includes("shirts")
) {
  if (requestedAudience === "mens") {
        terms.push(
      "mens shirt",
      "mens shirts",
      "men shirt",
      "men shirts",
      "men's shirt",
      "men's shirts",
      "mens top",
      "men top",
      "mens button shirt",
      "men button shirt",
      "men's button shirt",
      "button shirt",
      "button shirts",
      "mens-button-shirt",
      "mens-button-shirts",
      "shirt"
    );
  } else if (requestedAudience === "womens") {
    terms.push(
      "womens top",
      "women top",
      "women's top",
      "blouse",
      "top",
      "shirt"
    );
  } else {
    terms.push("top", "blouse", "shirt");
  }
}

  const explicitNonShoeRequest =
  q.includes("top") ||
  q.includes("tops") ||
  q.includes("shirt") ||
  q.includes("shirts") ||
  q.includes("blouse") ||
  q.includes("dress") ||
  q.includes("dresses") ||
  q.includes("bag") ||
  q.includes("bags") ||
  q.includes("accessories") ||
  q.includes("jewelry") ||
  q.includes("pants") ||
  q.includes("jeans") ||
  q.includes("denim");

if (
  !explicitNonShoeRequest &&
  (
    q.includes("shoe") ||
    q.includes("shoes") ||
    q.includes("sneaker") ||
    q.includes("sneakers") ||
    q.includes("footwear") ||
    q.includes("heel") ||
    q.includes("heels") ||
    q.includes("sandal") ||
    q.includes("sandals") ||
    q.includes("boot") ||
    q.includes("boots") ||
    q.includes("pump") ||
    q.includes("pumps") ||
    q.includes("slipper") ||
    q.includes("slippers") ||
    q.includes("athletic shoes") ||
    q.includes("canvas shoes")
  )
) {
  terms.push(
    "shoes",
    "shoe",
    "sneakers",
    "footwear",
    "athletic shoes",
    "canvas shoes",
    "slip on shoes",
    "slip on canvas shoes",
    "slipon canvas shoes",
    "mens athletic shoes",
    "men athletic shoes",
    "mens slipon canvas shoes",
    "men slipon canvas shoes",
    "mens-athletic-shoes",
    "men-slipon-canvas-shoes",
    "carmine athletic shoes",
    "red athletic shoes",
    "black athletic shoes",
    "white athletic shoes",
    "canvas shoes"
  );
}

  if (q.includes("skirt") || q.includes("skirts")) {
    terms.push("skirt");
  }

  if (q.includes("jewelry") || q.includes("accessories") || q.includes("accessory")) {
    terms.push("jewelry", "accessories");
  }

  if (q.includes("lavender")) {
    terms.push("lavender", "purple", "lilac");
  }

  if (q.includes("black")) {
    terms.push("black", "classic black", "evening");
  }

  if (q.includes("white")) {
    terms.push("white", "clean", "minimal");
  }

  if (q.includes("gold")) {
    terms.push("gold", "accessories", "jewelry");
  }

  if (q.includes("pink")) {
    terms.push("pink", "floral", "soft feminine");
  }

  if (q.includes("gift") || q.includes("gifts")) {
    terms.push("gift", "gift card", "beauty", "bag", "accessories");
  }

  if (q.includes("new") || q.includes("arrival") || q.includes("arrivals")) {
    terms.push("new", "dress", "bag", "accessories");
  }

  if (
  q.includes("complete the look") ||
  q.includes("outfit") ||
  q.includes("style") ||
  q.includes("look") ||
  q.includes("caption") ||
  q.includes("reel") ||
  q.includes("post") ||
  q.includes("promote")
) {
  terms.push("dress", "bag", "accessories", "jewelry", "top");
}

  const cleaned = q
    .replace(/show me/g, "")
    .replace(/find me/g, "")
    .replace(/find/g, "")
    .replace(/show/g, "")
    .replace(/suggest/g, "")
    .replace(/recommend/g, "")
    .replace(/shop/g, "")
    .replace(/please/g, "")
    .replace(/items/g, "")
    .replace(/products/g, "")
    .replace(/mood/g, "")
    .replace(/vibe/g, "")
    .replace(/aesthetic/g, "")
    .replace(/\s+/g, " ")
    .trim();

  if (cleaned) {
    terms.push(cleaned);
  }

  terms.push("dress", "bag", "top", "shoes", "accessories");

  return [...new Set(terms)].filter(Boolean).slice(0, 12);
}

async function hydrateDomengSuggestions(items) {
  if (!Array.isArray(items) || !items.length) {
    return [];
  }

  const hydrated = await Promise.all(
    items.map(async function (item) {
      const cleanItem = Object.assign({}, item);

      if (cleanItem.image && cleanItem.price) {
  cleanItem.url = normalizeDomengProductUrl(cleanItem.url);
  cleanItem.image = normalizeDomengImageUrl(cleanItem.image);

  if (cleanItem.priceValue === null || cleanItem.priceValue === undefined) {
    cleanItem.priceValue = normalizeDomengPriceNumber(cleanItem.price);
  }

  return cleanItem;
}

      try {
        const cleanUrl = normalizeDomengProductUrl(cleanItem.url);
        const productUrl = new URL(cleanUrl, window.location.origin);
        const productPath = productUrl.pathname;

        cleanItem.url = productPath;

        if (!productPath || !productPath.includes("/products/")) {
          return cleanItem;
        }

        const response = await fetch(`${productPath}.js`, {
          method: "GET",
          credentials: "same-origin"
        });

        if (!response.ok) {
          return cleanItem;
        }

        const product = await response.json();

        if (!cleanItem.image) {
          const rawImage =
            product.featured_image ||
            product.image ||
            (Array.isArray(product.images) ? product.images[0] : "");

          cleanItem.image = normalizeDomengImageUrl(rawImage);
        }

        if (!cleanItem.price && product.price) {
  cleanItem.price = formatMoney(product.price);
}

if (cleanItem.priceValue === null || cleanItem.priceValue === undefined) {
  cleanItem.priceValue = normalizeDomengPriceNumber(product.price || cleanItem.price);
}

        if (!cleanItem.description && product.description) {
          cleanItem.description = truncateText(stripHtml(product.description), 105);
        }

        if (!cleanItem.product_type) {
  cleanItem.product_type =
    product.product_type ||
    product.type ||
    "";
}

if (!cleanItem.vendor) {
  cleanItem.vendor = product.vendor || "";
}

if (!cleanItem.tags) {
  cleanItem.tags = Array.isArray(product.tags) ? product.tags.join(" ") : "";
}

if (!cleanItem.variantId && Array.isArray(product.variants)) {
  const firstAvailableVariant =
    product.variants.find(function (variant) {
      return variant && variant.available;
    }) || product.variants[0];

  cleanItem.variantId =
    firstAvailableVariant && firstAvailableVariant.id
      ? firstAvailableVariant.id
      : "";
}

        return cleanItem;
      } catch (error) {
        return cleanItem;
      }
    })
  );

  return hydrated;
}

function normalizeDomengImageUrl(value) {
  let url = "";

  if (!value) {
    return "";
  }

  if (typeof value === "object") {
    url = value.src || value.url || "";
  } else {
    url = String(value);
  }

  url = url.trim();

  if (!url) {
    return "";
  }

  if (url.startsWith("//")) {
    url = "https:" + url;
  }

  if (url.startsWith("http://")) {
    url = "https://" + url.slice(7);
  }

  if (url.startsWith("/")) {
    url = window.location.origin + url;
  }

  return url.startsWith("https://") ? url : "";
}

function renderSuggestionCards(items) {
  return items.map(item => {
    const cleanUrl = normalizeDomengProductUrl(item.url);
    const cleanImage = normalizeDomengImageUrl(item.image);
    const variantId = item.variantId || item.variant_id || "";

    return `
      <div class="domeng-mfb__suggestion-card">
        <a class="domeng-mfb__suggestion-thumb" href="${escapeHtml(cleanUrl)}" target="_self" rel="noopener">
          ${
            cleanImage
              ? `<img src="${escapeHtml(cleanImage)}" alt="${escapeHtml(item.title)}" loading="lazy">`
              : `<div class="domeng-mfb__suggestion-thumb-placeholder">MFB</div>`
          }
        </a>

        <div class="domeng-mfb__suggestion-content">
          <a href="${escapeHtml(cleanUrl)}" target="_self" rel="noopener" style="text-decoration:none;">
            <div class="domeng-mfb__suggestion-title">${escapeHtml(item.title)}</div>
          </a>

          <div class="domeng-mfb__suggestion-desc">${escapeHtml(item.description || "A curated Michelle Francisco Beauty piece.")}</div>

          <div class="domeng-mfb__suggestion-footer">
            <div class="domeng-mfb__suggestion-actions">
              <a class="domeng-mfb__suggestion-link" href="${escapeHtml(cleanUrl)}" target="_self" rel="noopener">View this piece</a>
              ${
                variantId
                  ? `<button class="domeng-mfb__suggestion-add" type="button" data-domeng-add-to-bag data-variant-id="${escapeHtml(variantId)}" data-product-title="${escapeHtml(item.title)}">Add to Bag</button>`
                  : ""
              }
            </div>

            ${item.price ? `<span class="domeng-mfb__suggestion-price">${escapeHtml(item.price)}</span>` : ""}
          </div>
        </div>
      </div>
    `;
  }).join("");
}

function normalizeDomengProductUrl(value) {
  let url = String(value || "").trim();

  if (!url || url === "#") {
    return "/collections/all";
  }

  if (url.startsWith("https://michellefranciscobeauty.com")) {
    try {
      return new URL(url).pathname;
    } catch (e) {
      return url;
    }
  }

  if (url.startsWith("http://michellefranciscobeauty.com")) {
    try {
      return new URL(url.replace("http://", "https://")).pathname;
    } catch (e) {
      return url;
    }
  }

  if (url.startsWith("/products/") || url.startsWith("/collections/")) {
    return url;
  }

  if (url.includes("/products/")) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return "/collections/all";
    }
  }

  return "/collections/all";
}

    function normalizeDomengHTML(text) {
      return String(text || "").replace(/Star/g, DOMENG_HTML);
    }

    function stripHtml(html) {
      return String(html || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function truncateText(text, maxLength = 110) {
      const clean = String(text || "").trim();

      if (clean.length <= maxLength) {
        return clean;
      }

      return clean.slice(0, maxLength).trim() + "…";
    }

    function formatMoney(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      let amount = Number(value);

      if (Number.isNaN(amount)) {
        return "";
      }

      if (amount > 999) {
        amount = amount / 100;
      }

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(amount);
    }
  }

  function getDomengMemoryLoginHtml() {
  const memoryEmail = getDomengMemoryEmail();

  if (memoryEmail) {
    return `
      <div class="domeng-mfb__account-prompt domeng-mfb__account-prompt--signedin">
        <strong>Star Memory Linked</strong>
        <span>Private shopping memory is linked to ${escapeHtml(maskDomengEmail(memoryEmail))}. Use the same email on your next visit to reload your conversations and style preferences.</span>
        <div class="domeng-mfb__account-actions">
          <button type="button" data-domeng-memory-clear>Change Email</button>
        </div>
      </div>
    `;
  }

  return `
    <div class="domeng-mfb__account-prompt">
      <strong>Activate Star Memory</strong>
      <span>Enter your email once so Star can remember your shopping conversations, style preferences, country, and Ambassador interest when you return.</span>
      <form data-domeng-memory-login-form class="domeng-mfb__memory-login-form">
        <input data-domeng-memory-email type="email" placeholder="Email address" autocomplete="email">
        <button type="submit">Save Memory</button>
      </form>
      <small>Your email is used only to link your private Star memory. Jeepney.io stores the memory key as a secure hash.</small>
    </div>
  `;
}

  function getAccountPromptHtml() {
    const customer = getCustomer();

    if (customer.loggedIn) {
      return `
        <div class="domeng-mfb__account-prompt domeng-mfb__account-prompt--signedin">
          <strong>Private AI memory ready</strong>
          <span>${DOMENG_HTML} can save your shopping conversations, sizes, country, and style preferences for this account only once secure memory is connected.</span>
        </div>
      `;
    }

    return `
      <div class="domeng-mfb__account-prompt">
        <strong>Unlock your personal AI stylist</strong>
        <span>Log in or create an account so ${DOMENG_HTML} can remember your style, size, favorites, country, and shopping conversations.</span>
        <div class="domeng-mfb__account-actions">
          <a href="${customer.loginUrl || DOMENG_CONFIG.links.login}">Log In</a>
          <a href="${customer.registerUrl || DOMENG_CONFIG.links.register}">Create Account</a>
        </div>
        <small>Guest chats may improve the public ${DOMENG_HTML} shopping knowledge base after privacy filtering.</small>
      </div>
    `;
  }

  function getCurrentProductHtml() {
  const product = getProduct();
  if (!product || !product.title) return "";

  const shipping = getProductShippingSummary(product);

  return `
    <div class="domeng-mfb__product-card">
      <strong>Currently viewing: ${escapeHtml(product.title)}</strong>
      <span>${shipping}</span>
    </div>
  `;
}
  function getSafeCustomerContext() {
  if (typeof window.MFB_DOMENG_REFRESH_CUSTOMER === "function") {
    try {
      window.MFB_DOMENG_REFRESH_CUSTOMER();
    } catch (e) {}
  }

  const customer = window.MFB_DOMENG_CUSTOMER || getCustomer() || {};
  const memoryEmail = getDomengMemoryEmail();

  return {
    loggedIn: !!customer.loggedIn || !!memoryEmail,
    customerIdHint: customer.customerId || null,
    customerId: customer.customerId || null,
    memoryEmail: memoryEmail || null,
    firstName: customer.firstName || null
  };
}

  function isMCollectionCountry(country) {
  if (!country) return false;

  return M_COLLECTION_COUNTRIES.some(function (item) {
    return normalizeText(item) === normalizeText(country);
  });
}

  function buildShippingContext(query) {
    const product = getProduct();
    const country = detectCountry(query);

    return {
      detectedCountry: country,
      productTitle: product ? product.title : null,
      productVendorPublicGroup: product ? getPublicProductGroup(product) : null,
      productDescriptionRestriction: product ? detectDescriptionRestriction(product.description || "") : null,
      mCollectionEligible: country ? isMCollectionCountry(country) : null
    };
  }

  function domengPlainMemoryText(value) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function domengShortMemoryText(value, maxLength = 90) {
  const clean = domengPlainMemoryText(value);

  if (clean.length <= maxLength) {
    return clean;
  }

  return clean.slice(0, maxLength).trim() + "…";
}

  function getPersistentMemorySummary() {
  const memory = DOMENG_PERSISTENT.memory || {};
  const parts = [];

  if (memory.favorite_mood && memory.favorite_mood.value) {
    parts.push(`favorite mood: ${memory.favorite_mood.value}`);
  }

  if (memory.preferred_category && memory.preferred_category.value) {
    parts.push(`preferred category: ${memory.preferred_category.value}`);
  }

  if (memory.shipping_country && memory.shipping_country.value) {
    parts.push(`shipping country: ${memory.shipping_country.value}`);
  }

  if (memory.ambassador_interest && memory.ambassador_interest.value === "yes") {
    parts.push(`Ambassador interest: yes`);
  }

  return parts;
}

function answerMemoryQuestion(query) {
  const memoryParts = getPersistentMemorySummary();
  const messages = Array.isArray(DOMENG_PERSISTENT.messages)
    ? DOMENG_PERSISTENT.messages.slice(-6)
    : [];

  if (!memoryParts.length && !messages.length) {
    return `I do not have enough saved memory yet.

Tell me your style mood, preferred category, shipping country, size concerns, or budget. For example:

“I like soft feminine dresses and I ship to the United States.”

After that, I can remember it for your next visit.`;
  }

  const recentLines = messages.map(function (msg) {
    const role = msg.role === "assistant" ? "Star" : "You";
    return `${role}: ${domengShortMemoryText(msg.message_text || "", 90)}`;
  });

  return `Here is what I remember from your private Star memory:

${memoryParts.length ? memoryParts.map(item => `• ${item}`).join("\n") : "• No long-term style tags saved yet."}

Recent conversation memory:
${recentLines.length ? recentLines.map(item => `• ${item}`).join("\n") : "• No recent conversation lines yet."}

Based on this, I should prioritize pieces that match your saved style direction instead of starting from zero.`;
}

function answerBasedOnPreviousStyle(query) {
  const memory = DOMENG_PERSISTENT.memory || {};

  const mood = memory.favorite_mood && memory.favorite_mood.value
    ? memory.favorite_mood.value
    : "";

  const category = memory.preferred_category && memory.preferred_category.value
    ? memory.preferred_category.value
    : "";

  const country = memory.shipping_country && memory.shipping_country.value
    ? memory.shipping_country.value
    : "";

  if (!mood && !category && !country) {
    return `I do not have enough saved style memory yet.

Tell me something like:
“I like soft feminine dresses and I ship to the United States.”

Then I can recommend based on your previous style.`;
  }

  const moodText = mood ? mood.replace(/_/g, " ") : "your saved style";
  const categoryText = category ? category.replace(/_/g, " ") : "curated pieces";
  const countryText = country ? ` and keep ${country} shipping in mind` : "";

  return `Based on your previous style memory, I should look for ${moodText} ${categoryText}${countryText}.

My recommendation:
1. Start with soft, elegant dresses.
2. Prioritize feminine silhouettes, graceful colors, and pieces that feel polished but not loud.
3. Choose items that fit your saved shipping country before falling in love with the piece.
4. Complete the look with a bag or accessory only after the main dress is chosen.

Ask me:
“Show me pieces based on my memory”
or
“Find soft feminine dresses for the United States”`;
}

function formatProductPageMoney(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  let amount = value;

  if (typeof amount === "string") {
    amount = amount
      .replace(/USD/gi, "")
      .replace(/\$/g, "")
      .replace(/,/g, "")
      .trim();
  }

  amount = Number(amount);

  if (Number.isNaN(amount)) {
    return "";
  }

  if (amount > 999) {
    amount = amount / 100;
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(amount);
}

function normalizeProductPageText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[-_/]+/g, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function productPageHas(text, term) {
  const cleanText = normalizeProductPageText(text);
  const cleanTerm = normalizeProductPageText(term);

  if (!cleanTerm) {
    return false;
  }

  const pattern = new RegExp("\\b" + cleanTerm.replace(/\s+/g, "\\s+") + "\\b", "i");
  return pattern.test(cleanText);
}

function getProductPageText(product) {
  return [
    product && product.title,
    product && product.description,
    product && product.product_type,
    product && product.type,
    product && product.vendor,
    product && Array.isArray(product.tags) ? product.tags.join(" ") : ""
  ].join(" ");
}

function answerCurrentProductQuestion(query, product) {
  const q = String(query || "").toLowerCase();

  const title = product && product.title ? product.title : "this product";
  const productType =
    product.product_type ||
    product.type ||
    product.category ||
    "curated piece";

  const priceText = product.price
    ? formatProductPageMoney(product.price)
    : "";

  const description = product.description
    ? domengPlainMemoryText(product.description)
    : "";

  const shortDescription = description
    ? domengShortMemoryText(description, 180)
    : "This is a curated Michelle Francisco Beauty piece.";

  const shippingSummary = getProductShippingSummary(product);

  const availableVariants = Array.isArray(product.variants)
    ? product.variants
        .filter(function (variant) {
          return variant && variant.available;
        })
        .map(function (variant) {
          return variant.title;
        })
        .filter(Boolean)
    : [];

  const variantLine = availableVariants.length
    ? `Available options: ${availableVariants.slice(0, 8).join(", ")}.`
    : "Please check the product page for currently available options.";

  if (
    q.includes("should i buy") ||
    q.includes("why should i buy") ||
    q.includes("sell me") ||
    q.includes("convince me")
  ) {
    return `${DOMENG_HTML} product take:

${escapeHtml(title)}${priceText ? ` is currently listed at ${escapeHtml(priceText)}` : ""}.

Why it can work:
1. It fits the Michelle Francisco Beauty direction of curated elegance and everyday polish.
2. It gives the shopper a clear style anchor instead of a random purchase.
3. It can be styled around mood, occasion, and country availability.
4. ${escapeHtml(shortDescription)}

${escapeHtml(shippingSummary)}

My recommendation:
If this matches your mood, size, and shipping country, it is worth considering. Ask me next:
“Can this ship to my country?”
or
“What can I pair with this?”`;
  }

  if (
    q.includes("good for") ||
    q.includes("occasion") ||
    q.includes("date night") ||
    q.includes("brunch") ||
    q.includes("work") ||
    q.includes("office") ||
    q.includes("vacation") ||
    q.includes("everyday")
  ) {
    return answerProductOccasionFit(query, product);
  }

  if (
    q.includes("pair") ||
    q.includes("match") ||
    q.includes("style this") ||
    q.includes("complete the look") ||
    q.includes("wear with")
  ) {
    return answerProductPairing(query, product);
  }

  if (
    q.includes("caption") ||
    q.includes("instagram") ||
    q.includes("facebook") ||
    q.includes("tiktok") ||
    q.includes("reel") ||
    q.includes("ambassador")
  ) {
    return answerProductAmbassadorContent(query, product);
  }

  if (
    q.includes("size") ||
    q.includes("fit") ||
    q.includes("small") ||
    q.includes("large") ||
    q.includes("medium")
  ) {
    return `For ${escapeHtml(title)}, sizing should be checked against the product measurements and available variants.

${escapeHtml(variantLine)}

My fit rule:
1. Choose your usual size if you prefer a standard fit.
2. Size up if you are between sizes or want a more relaxed look.
3. Size down only if the product description clearly says oversized or relaxed.
4. For gifts, choose the safer larger option if unsure.

I can help better if you tell me your usual size and whether you prefer fitted or relaxed.`;
  }

  return `${DOMENG_HTML} product summary:

Product: ${escapeHtml(title)}
${priceText ? `Price: ${escapeHtml(priceText)}` : ""}
Category/type: ${escapeHtml(productType)}

${escapeHtml(shortDescription)}

${escapeHtml(shippingSummary)}

${escapeHtml(variantLine)}

Ask me:
“Can this ship to the United States?”
“What can I pair with this?”
“Is this good for date night?”
“Write an Ambassador caption for this product.”`;
}

function answerProductOccasionFit(query, product) {
  const q = String(query || "").toLowerCase();
  const title = product && product.title ? product.title : "this product";
  const text = getProductPageText(product);

  let occasion = "everyday styling";

  if (q.includes("date")) occasion = "date night";
  if (q.includes("brunch")) occasion = "brunch";
  if (q.includes("work") || q.includes("office")) occasion = "work or office";
  if (q.includes("vacation") || q.includes("travel")) occasion = "vacation or travel";
  if (q.includes("party") || q.includes("event")) occasion = "events or parties";

  const isShoe =
    productPageHas(text, "shoe") ||
    productPageHas(text, "shoes") ||
    productPageHas(text, "sneaker") ||
    productPageHas(text, "athletic shoes") ||
    productPageHas(text, "canvas shoes");

  const isDress =
    productPageHas(text, "dress") ||
    productPageHas(text, "gown");

  const isBag =
    productPageHas(text, "bag") ||
    productPageHas(text, "tote") ||
    productPageHas(text, "handbag");

  if (isShoe) {
    return `${escapeHtml(title)} can work for ${escapeHtml(occasion)} if the outfit direction is casual, sporty, travel-friendly, or street-polished.

Best use:
1. Pair with clean basics, denim, casual dresses, or relaxed sets.
2. Keep the rest of the look simple so the footwear feels intentional.
3. Use it for comfort-first days, travel, errands, and lifestyle looks.

For formal date night or luxury evening styling, I would choose heels, sandals, pumps, or a more elevated shoe instead.`;
  }

  if (isDress) {
    return `${escapeHtml(title)} can work beautifully for ${escapeHtml(occasion)} if the color, length, and fit match the mood.

Style direction:
1. For date night, add a sleek bag and softer jewelry.
2. For brunch, keep it lighter, fresher, and more feminine.
3. For work, add structure such as a blazer or clean outer layer.
4. For vacation, keep the accessories easy and photo-ready.

Tell me your country and size preference, and I can help check if it is practical to buy.`;
  }

  if (isBag) {
    return `${escapeHtml(title)} can work for ${escapeHtml(occasion)} as a finishing piece.

Best use:
1. Use it to elevate a simple dress or top.
2. Match it with one color from your outfit.
3. Keep the outfit clean if the bag has strong color or texture.
4. For travel, check if the size fits your daily essentials.`;
  }

  return `${escapeHtml(title)} can work for ${escapeHtml(occasion)}, depending on how you style it.

My styling rule:
Use this piece as either the main statement or the supporting accent. Do not let it compete with too many other strong pieces.`;
}

function answerProductPairing(query, product) {
  const title = product && product.title ? product.title : "this product";
  const text = getProductPageText(product);

  const isShoe =
    productPageHas(text, "shoe") ||
    productPageHas(text, "shoes") ||
    productPageHas(text, "sneaker") ||
    productPageHas(text, "athletic shoes") ||
    productPageHas(text, "canvas shoes");

  const isDress =
    productPageHas(text, "dress") ||
    productPageHas(text, "gown");

  const isBag =
    productPageHas(text, "bag") ||
    productPageHas(text, "tote") ||
    productPageHas(text, "handbag");

  if (isShoe) {
    return `To style ${escapeHtml(title)}:

1. Pair with denim, joggers, casual dresses, or relaxed everyday sets.
2. Keep the top clean and simple.
3. Use one matching color from the shoe in the outfit.
4. Add a minimal bag to keep the look intentional.
5. For a sharper look, pair with black, white, or neutral basics.`;
  }

  if (isDress) {
    return `To complete the look for ${escapeHtml(title)}:

1. Start with a bag that matches the dress mood.
2. Add simple jewelry if the dress has strong details.
3. Choose shoes based on occasion: sandals for daytime, heels for evening, sneakers for casual.
4. Use soft makeup and clean hair for a polished Michelle Francisco Beauty look.`;
  }

  if (isBag) {
    return `To style ${escapeHtml(title)}:

1. Pair it with a simple dress, neutral top, or clean casual outfit.
2. Let the bag be the finishing statement.
3. Match it with shoes or one outfit accent.
4. Keep jewelry minimal if the bag already has strong detail.`;
  }

  return `To style ${escapeHtml(title)}:

1. Choose one main mood: soft, polished, casual, bold, or travel-ready.
2. Pair it with clean supporting pieces.
3. Repeat one color from the item elsewhere in the outfit.
4. Keep accessories intentional, not crowded.`;
}

function answerProductAmbassadorContent(query, product) {
  const title = product && product.title ? product.title : "this Michelle Francisco Beauty piece";
  const priceText = product.price ? formatProductPageMoney(product.price) : "";
  const q = String(query || "").toLowerCase();

  if (q.includes("tiktok") || q.includes("reel")) {
    return `Here is a short Ambassador Reel or TikTok script for ${escapeHtml(title)}:

Hook:
“Here is one curated piece I would style for an effortless Michelle Francisco Beauty look.”

Scene 1:
Show the product clearly.

Voiceover:
“This caught my eye because it feels wearable, polished, and easy to style.”

Scene 2:
Show the detail, color, shape, or product page.

Voiceover:
“I like pieces that make an outfit feel intentional without making it complicated.”

Scene 3:
Show how you would style it.

Voiceover:
“You can shop this through my Michelle Francisco Beauty Ambassador link.”

Caption:
Curated elegance, styled for real life. Shop ${escapeHtml(title)} through my Ambassador link.

Hashtags:
#MichelleFranciscoBeauty #MCollection #AmbassadorStyle #CuratedFashion #SoftLuxury #StyleFinds`;
  }

  return `Here is an Ambassador caption for ${escapeHtml(title)}:

Curated elegance starts with one intentional piece.

I found ${escapeHtml(title)} from Michelle Francisco Beauty${priceText ? `, currently listed at ${escapeHtml(priceText)}` : ""}. It is the kind of piece that can help complete a look without overcomplicating the outfit.

Style it your way, wear it with confidence, and shop through my Ambassador link.

Suggested hashtags:
#MichelleFranciscoBeauty #MCollection #AmbassadorStyle #CuratedFashion #ElegantStyle #StyleFinds`;
}

function isDomengCartQuery(query) {
  const q = String(query || "").toLowerCase();

  return (
    q.includes("my bag") ||
    q.includes("my cart") ||
    q.includes("cart") ||
    q.includes("checkout") ||
    q.includes("complete my bag") ||
    q.includes("complete the bag") ||
    q.includes("what is in my bag") ||
    q.includes("what's in my bag") ||
    q.includes("whats in my bag") ||
    q.includes("what is in my cart") ||
    q.includes("what's in my cart") ||
    q.includes("whats in my cart") ||
    q.includes("does my bag match") ||
    q.includes("do these match") ||
    q.includes("should i checkout") ||
    q.includes("ready to checkout") ||
    q.includes("find one more") ||
    q.includes("one more piece")
  );
}

async function getDomengCart() {
  try {
    const response = await fetch("/cart.js", {
      method: "GET",
      headers: {
        "Accept": "application/json"
      },
      credentials: "same-origin"
    });

    if (!response.ok) {
      console.warn("DOMENG cart response not OK:", response.status);
      return {
        item_count: 0,
        items: [],
        total_price: 0
      };
    }

    const cart = await response.json();

    return cart || {
      item_count: 0,
      items: [],
      total_price: 0
    };
  } catch (error) {
    console.warn("DOMENG cart read failed:", error);

    return {
      item_count: 0,
      items: [],
      total_price: 0
    };
  }
}

function formatDomengCartMoney(cents) {
  let amount = Number(cents || 0);

  if (Number.isNaN(amount)) {
    amount = 0;
  }

  amount = amount / 100;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(amount);
}

function normalizeDomengCartText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[-_/]+/g, " ")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function domengCartTextHas(text, term) {
  const cleanText = normalizeDomengCartText(text);
  const cleanTerm = normalizeDomengCartText(term);

  if (!cleanText || !cleanTerm) {
    return false;
  }

  return cleanText.includes(cleanTerm);
}

function getDomengCartItemType(item) {
  const text = normalizeDomengCartText([
    item && item.product_title,
    item && item.title,
    item && item.product_type,
    item && item.variant_title,
    item && item.vendor
  ].join(" "));

  if (
    domengCartTextHas(text, "shoe") ||
    domengCartTextHas(text, "shoes") ||
    domengCartTextHas(text, "sneaker") ||
    domengCartTextHas(text, "athletic shoes") ||
    domengCartTextHas(text, "canvas shoes")
  ) {
    return "shoes";
  }

  if (
    domengCartTextHas(text, "shirt") ||
    domengCartTextHas(text, "top") ||
    domengCartTextHas(text, "button shirt")
  ) {
    return "top";
  }

  if (
    domengCartTextHas(text, "dress") ||
    domengCartTextHas(text, "gown")
  ) {
    return "dress";
  }

  if (
    domengCartTextHas(text, "bag") ||
    domengCartTextHas(text, "tote") ||
    domengCartTextHas(text, "handbag")
  ) {
    return "bag";
  }

  if (
    domengCartTextHas(text, "jewelry") ||
    domengCartTextHas(text, "accessories") ||
    domengCartTextHas(text, "accessory")
  ) {
    return "accessories";
  }

  if (
    domengCartTextHas(text, "pants") ||
    domengCartTextHas(text, "jeans") ||
    domengCartTextHas(text, "denim") ||
    domengCartTextHas(text, "trousers")
  ) {
    return "bottom";
  }

  return "piece";
}

function summarizeDomengCartTypes(cart) {
  const items = Array.isArray(cart && cart.items) ? cart.items : [];
  const types = {};

  items.forEach(function (item) {
    const type = getDomengCartItemType(item);
    const quantity = Number(item && item.quantity ? item.quantity : 1);

    types[type] = (types[type] || 0) + quantity;
  });

  return types;
}

function getDomengCartCompletionAdvice(cart) {
  const types = summarizeDomengCartTypes(cart);

  const hasDress = !!types.dress;
  const hasTop = !!types.top;
  const hasShoes = !!types.shoes;
  const hasBag = !!types.bag;
  const hasAccessories = !!types.accessories;
  const hasBottom = !!types.bottom;

  const advice = [];

  if (hasDress && !hasBag) {
    advice.push("Add a bag to complete the dress look.");
  }

  if (hasDress && !hasShoes) {
    advice.push("Add shoes or sandals to make the outfit checkout-ready.");
  }

  if (hasTop && !hasBottom) {
    advice.push("Add pants, jeans, skirt, or another bottom to complete the outfit.");
  }

  if ((hasTop || hasDress) && !hasAccessories) {
    advice.push("Add one clean accessory if you want the look to feel more intentional.");
  }

  if (hasShoes && !hasTop && !hasDress) {
    advice.push("Add a top, shirt, dress, or full outfit piece to build around the shoes.");
  }

  if (!advice.length) {
    advice.push("Your bag already has a good foundation. Review size, quantity, and shipping before checkout.");
  }

  return advice;
}

function getDomengCartSearchPrompt(cart) {
  const types = summarizeDomengCartTypes(cart);

  if (types.dress && !types.bag) {
    return "Show me bags to complete my bag";
  }

  if (types.dress && !types.shoes) {
    return "Show me shoes to complete my bag";
  }

  if (types.top && !types.bottom) {
    return "Show me pants or jeans to complete my bag";
  }

  if ((types.top || types.dress) && !types.accessories) {
    return "Show me accessories to complete my bag";
  }

  if (types.shoes && !types.top && !types.dress) {
    return "Show me tops to match my shoes";
  }

  return "Show me one more piece to complete my bag";
}

async function answerDomengCartQuestion(query) {
  try {
    const q = String(query || "").toLowerCase();
    const cart = await getDomengCart();
    const items = Array.isArray(cart && cart.items) ? cart.items : [];

    if (!items.length) {
      return `Your bag is currently empty.

Start here:
<a href="${DOMENG_CONFIG.links.shopAll}">Shop All</a>

You can also ask me:
“Show me soft feminine dresses under $100”
“Show me shoes below $200”
“Find a date night outfit”`;
    }

    const itemLines = items.slice(0, 8).map(function (item) {
      const title = item.product_title || item.title || "Item";
      const quantity = Number(item.quantity || 1);
      const linePrice = formatDomengCartMoney(item.final_line_price || item.line_price || 0);

      return `• ${quantity} × ${title} — ${linePrice}`;
    });

    const subtotal = formatDomengCartMoney(cart.total_price || 0);
    const advice = getDomengCartCompletionAdvice(cart);
    const searchPrompt = getDomengCartSearchPrompt(cart);

    if (
      q.includes("checkout") ||
      q.includes("should i checkout") ||
      q.includes("ready to checkout")
    ) {
      return `Your bag has ${items.length} item${items.length === 1 ? "" : "s"}.

${itemLines.join("\n")}

Estimated subtotal: ${subtotal}

My checkout advice:
${advice.map(function (line, index) {
  return `${index + 1}. ${line}`;
}).join("\n")}

Ready to continue?
<a href="/cart">Review Bag</a>
<a href="/checkout">Checkout Now</a>`;
    }

    if (
      q.includes("complete") ||
      q.includes("find one more") ||
      q.includes("one more piece") ||
      q.includes("finish")
    ) {
      return `Here is how I would complete your bag:

Current bag:
${itemLines.join("\n")}

Estimated subtotal: ${subtotal}

Recommended next move:
${advice.map(function (line, index) {
  return `${index + 1}. ${line}`;
}).join("\n")}

Ask me next:
“${searchPrompt}”

Then I can show product cards you can add directly to your bag.`;
    }

    if (
      q.includes("match") ||
      q.includes("go together") ||
      q.includes("does everything") ||
      q.includes("does my bag")
    ) {
      return `Here is my Star style read on your bag:

${itemLines.join("\n")}

Estimated subtotal: ${subtotal}

Style check:
${advice.map(function (line, index) {
  return `${index + 1}. ${line}`;
}).join("\n")}

Rule:
A strong bag usually needs one main statement, one support piece, and one finishing piece. Do not overcrowd the look.`;
    }

    return `Here is what is currently in your bag:

${itemLines.join("\n")}

Estimated subtotal: ${subtotal}

Star recommendation:
${advice.map(function (line, index) {
  return `${index + 1}. ${line}`;
}).join("\n")}

Next:
<a href="/cart">Review Bag</a>
<a href="/checkout">Checkout Now</a>

You can also ask:
“Complete my bag”
“Does my bag match?”
“Find one more piece”`;
  } catch (error) {
    console.error("DOMENG cart answer internal failure:", error);

    return `I had trouble reading your bag automatically.

Please open your bag here:
<a href="/cart">View Bag</a>

You can also continue shopping and ask me to recommend products.`;
  }
}

  function fallbackAnswer(query) {
  const q = String(query || "").toLowerCase();
  const product = getProduct();
  const bridge = "";

  if (
  q.includes("what do you remember") ||
  q.includes("what do you know about me") ||
  q.includes("my memory") ||
  q.includes("previous conversation") ||
  q.includes("previous conversations") ||
  q.includes("past conversation") ||
  q.includes("past conversations")
) {
  return answerMemoryQuestion(query);
}

if (
  q.includes("based on my previous style") ||
  q.includes("based on my memory") ||
  q.includes("based on what you remember") ||
  q.includes("what should i shop for")
) {
  return answerBasedOnPreviousStyle(query);
}

if (
  q.includes("i'm a man") ||
  q.includes("im a man") ||
  q.includes("i am a man") ||
  q.includes("i am male") ||
  q.includes("male shopper")
) {
  DOMENG_SESSION.lastAudience = "mens";

  return `Got it. For this session, I will prioritize men’s pieces when you ask for tops, shirts, shoes, bags, accessories, or complete looks.

Try:
“Show me men’s shirts to match my shoes”
or
“Show me tops to match my shoes”`;
}

if (
  q.includes("i'm a woman") ||
  q.includes("im a woman") ||
  q.includes("i am a woman") ||
  q.includes("i am female") ||
  q.includes("female shopper")
) {
  DOMENG_SESSION.lastAudience = "womens";

  return `Got it. For this session, I will prioritize women’s pieces when you ask for dresses, tops, shoes, bags, accessories, or complete looks.`;
}

if (
  product &&
  (
    q.includes("this product") ||
    q.includes("this item") ||
    q.includes("this piece") ||
    q.includes("current product") ||
    q.includes("current item") ||
    q.includes("is this good") ||
    q.includes("should i buy this") ||
    q.includes("tell me about this") ||
    q.includes("summarize this") ||
    q.includes("why should i buy") ||
    q.includes("sell me this") ||
    q.includes("pair with this") ||
    q.includes("style this") ||
    q.includes("complete the look") ||
    q.includes("wear with this")
  )
) {
  return answerCurrentProductQuestion(query, product);
}

const fallbackRequiredTerms = getRequiredProductTerms(query);

const fallbackShoeTerms = [
  "shoe",
  "shoes",
  "sneaker",
  "sneakers",
  "footwear",
  "heel",
  "heels",
  "sandal",
  "sandals",
  "boot",
  "boots",
  "pump",
  "pumps",
  "slipper",
  "slippers",
  "athletic shoes",
  "canvas shoes",
  "slip on canvas shoes",
  "slipon canvas shoes",
  "mens athletic shoes",
  "men athletic shoes",
  "mens slipon canvas shoes",
  "men slipon canvas shoes"
];

const fallbackRequestedShoes = fallbackRequiredTerms.some(function (term) {
  return fallbackShoeTerms.some(function (shoeTerm) {
    return normalizeDomengSearchText(term) === normalizeDomengSearchText(shoeTerm);
  });
});

if (fallbackRequestedShoes) {
  return `I checked the footwear edit, including athletic shoes, canvas shoes, sneakers, heels, sandals, boots, pumps, and slippers.

I could not find a strong footwear match from the current searchable product data.

Try these:
1. Search the store directly for “athletic shoes”
2. Search “canvas shoes,” “sneakers,” or “men’s shoes”
3. Ask me for a different category such as dresses, tops, bags, denim, or accessories

Open search:
<a href="/search?q=athletic%20shoes&type=product">Search Athletic Shoes</a>`;
}

if (q.includes("jeans") || q.includes("denim") || q.includes("pants") || q.includes("trousers")) {
  return `I checked for jeans, denim, pants, and trousers, but I do not want to show you unrelated items like shoes or bags.

I could not find a strong jeans or denim match right now.

You can try:
1. Checking the M Collection directly
2. Searching “denim”
3. Asking me for another category such as dresses, tops, bags, shoes, or accessories`;
}

  if (q.includes("style quiz") || q.includes("find my style")) {
    return `Let us build your personal style direction.

Answer these 5 questions:

1. What mood are you shopping for?
Soft Feminine, Power Woman, Date Night, Vacation, Minimalist Chic, Luxe Casual

2. What is the occasion?
Brunch, Work, Date Night, Vacation, Everyday, Gift

3. What category do you want?
Dress, Bag, Top, Skirt, Jewelry, Loungewear

4. What color direction do you prefer?
Lavender, Black, White, Gold, Pink, Neutral

5. What is your budget?
Under $50, $50 to $100, $100 to $150, or No budget limit

Reply with your answers, and ${DOMENG_HTML} will curate a style direction for you.`;
  }

  if (
    q.includes("caption") ||
    q.includes("instagram post") ||
    q.includes("facebook post") ||
    q.includes("tiktok") ||
    q.includes("reel script") ||
    q.includes("what should i post")
  ) {
    if (q.includes("tiktok") || q.includes("reel script") || q.includes("reels")) {
  const featured = product && product.title ? product.title : "your favorite M Collection piece";

  return `Here is a simple Ambassador video script for ${escapeHtml(featured)}:

Hook:
“Here is how I would style one elegant piece for a soft luxury look.”

Scene 1:
Show the item clearly in natural light.

Voiceover:
“This piece feels feminine, easy to wear, and quietly polished.”

Scene 2:
Show the detail, fabric, shape, color, or styling angle.

Voiceover:
“I love pieces that can make an outfit feel intentional without trying too hard.”

Scene 3:
Show the complete look or product page.

Voiceover:
“You can shop this through my Ambassador link and discover more curated pieces from Michelle Francisco Beauty.”

Caption:
Soft elegance, curated daily. Shop my Michelle Francisco Beauty Ambassador link.

Hashtags:
#MichelleFranciscoBeauty #MCollection #AmbassadorStyle #SoftLuxury #ElegantStyle #FashionFinds`;
}
    if (product && product.title) {
      return `Here is an elegant Ambassador caption for ${escapeHtml(product.title)}:

Elegance is not loud. It is intentional.

I found this curated piece from Michelle Francisco Beauty for women who love softness, confidence, and effortless style.

Shop through my Ambassador link and discover your next signature look.

Suggested hashtags:
#MichelleFranciscoBeauty #MCollection #AmbassadorStyle #CuratedFashion #SoftLuxury #ElegantStyle`;
    }

    return `Here is an elegant Ambassador caption you can use today:

Your next signature look starts with one curated piece.

Michelle Francisco Beauty brings together fashion, beauty, lifestyle, and giftable finds for women who love elegance, confidence, and softness.

Shop M Collection through my Ambassador link and discover pieces curated for your mood, occasion, and lifestyle.

Suggested hashtags:
#MichelleFranciscoBeauty #MCollection #AmbassadorStyle #CuratedFashion #SoftLuxury #ElegantStyle`;
  }

  if (
    q.includes("ambassador") ||
    q.includes("affiliate") ||
    q.includes("earn") ||
    q.includes("commission") ||
    q.includes("creator") ||
    q.includes("influencer") ||
    q.includes("promote")
  ) {
    const country = detectCountry(query);

    const countryLine = country
      ? isMCollectionCountry(country)
        ? `Good news. M Collection currently supports delivery to ${escapeHtml(country)}, making it a strong market for Ambassador promotions.`
        : `M Collection may not currently deliver directly to ${escapeHtml(country)}. You may still apply if your audience is in the 44 supported delivery countries.`
      : `M Collection currently supports delivery to 44 countries, making the Ambassador Program ideal for creators with audiences in supported delivery markets.`;

    return `Michelle Francisco Beauty welcomes style creators, beauty creators, lifestyle voices, shoppers, students, stylists, bloggers, and community leaders to become M Collection Ambassadors.

${countryLine}

Ambassadors earn 10% commission on the net product subtotal of eligible referred sales by sharing their unique Ambassador link.

Best ways to promote:
1. Share mood-based edits such as Soft Feminine, Power Woman, Date Night, Vacation, and Minimalist Chic.
2. Post product links with your Ambassador link.
3. Create outfit captions, reels, stories, and gift guides.
4. Ask Star to write captions, product scripts, or country-specific promotions for you.

Apply here:
<a href="${DOMENG_CONFIG.links.ambassador}" target="_blank" rel="noopener">Become an Ambassador</a>`;
  }
      if (q.includes("review") || q.includes("rating") || q.includes("q&a") || q.includes("ask a question")) { return `You can read and leave reviews right on each product page, photos and videos included -- and leaving one can earn you a one-time discount code as a thank-you. Every product page also has its own Questions & Answers section for anything specific to that piece.`; }

  if (isShippingQuery(q)) {
    return answerShippingQuery(query, product);
  }

  const moodAnswer =
  typeof getMoodAnswer === "function"
    ? getMoodAnswer(query)
    : "";

if (moodAnswer) {
  return `${bridge}${moodAnswer}

Would you like me to narrow this into dresses, bags, tops, accessories, or a complete outfit?`;
}

  if (q.includes("new") || q.includes("arrival") || q.includes("shop new arrivals")) {
    return `Here are the newest pieces curated for you: <a href="${DOMENG_CONFIG.links.newArrivals}">Shop New Arrivals</a>.`;
  }

  if (q.includes("dress") || q.includes("dresses")) {
    return `For an elegant feminine look, start with the dress edit: <a href="${DOMENG_CONFIG.links.dresses}">Shop Dresses</a>. Tell me your shipping country and I can help check availability.`;
  }

  if (q.includes("size") || q.includes("fit")) {
    if (product && product.variants && product.variants.length) {
      const available = product.variants
        .filter(v => v.available)
        .map(v => v.title)
        .filter(Boolean);

      return available.length
        ? `For this item, the currently available options include: ${escapeHtml(available.join(", "))}. For fit, use the product measurements and choose your usual size. If you are between sizes or prefer a relaxed look, consider sizing up.`
        : `This item appears unavailable right now. I can help you find a similar item with available sizes.`;
    }

    return `I can help with sizing. Open a product page or tell me the item name, your usual size, and whether you prefer fitted or relaxed.`;
  }

  if (
  q.includes("similar") ||
  q.includes("like this") ||
  q.includes("something like this") ||
  q.includes("more like this") ||
  q.includes("same style") ||
  q.includes("same type")
) {
  if (product) {
    return `I looked for similar pieces to ${escapeHtml(product.title)}, but I could not find a strong related match from the current searchable product data.

Try:
1. Asking by category, like “show me similar shirts”
2. Asking by color, like “show me eggplant shirts”
3. Asking by budget, like “show me similar products under $100”
4. Opening the full collection here:
<a href="${DOMENG_CONFIG.links.shopAll}">Shop All</a>`;
  }

  return `Tell me the product or style you like, and I will help you find similar pieces.`;
}

  if (q.includes("complete the look") || q.includes("pair") || q.includes("match")) {
    if (product) {
      return `To complete the look for ${escapeHtml(product.title)}, pair it with complementary colors, clean accessories, and either a soft neutral or lavender accent. Tell me your occasion and I will style it more precisely.`;
    }

    return `Tell me the piece you want to style, your occasion, and your preferred mood: elegant, casual, soft, bold, or travel-ready.`;
  }

  if (q.includes("track") || q.includes("order")) {
    return `You can track your order here: <a href="${DOMENG_CONFIG.links.trackOrder}">Track Order</a>.`;
  }

  if (q.includes("gift")) {
    return `A Michelle Francisco Beauty Gift Card is the safest elegant choice: <a href="${DOMENG_CONFIG.links.giftCard}">Open Gift Card</a>.`;
  }

  if (
  q.includes("login") ||
  q.includes("account")
) {
    const customer = getCustomer();

    if (customer.loggedIn) {
      return `You are signed in. Once secure memory is connected, ${DOMENG_HTML} will remember your private shopping conversations for this account only.`;
    }

    return `For the best AI shopping experience, please <a href="${customer.loginUrl || DOMENG_CONFIG.links.login}">log in</a> or <a href="${customer.registerUrl || DOMENG_CONFIG.links.register}">create an account</a>. Then ${DOMENG_HTML} can remember your style, sizes, favorites, country, and shopping conversations.`;
  }

return `Tell me your mood, occasion, or what you're shopping for, and I'll help you find it.`;
}

  function answerShippingQuery(query, product) {
    const country = detectCountry(query);

    if (!country) {
      return `Please tell me your shipping country so I can check availability. For example: “Can this ship to Canada?” or “Can this ship to the Philippines?”`;
    }

    if (!product) {
      if (M_COLLECTION_COUNTRIES.includes(country)) {
        return `Yes, M Collection currently ships to ${escapeHtml(country)}. Some individual products may still have specific shipping restrictions, so I will check the product page when you choose an item.`;
      }

      return `M Collection currently ships to 44 countries, and ${escapeHtml(country)} is not on that list. I can still help you look for Michelle Francisco Beauty items with broader shipping availability.`;
    }

    const restriction = detectDescriptionRestriction(product.description || "");
    const group = getPublicProductGroup(product);

    if (restriction.type === "us_only") {
      return country === "United States"
        ? `Yes. Based on this product’s shipping note, this item can ship to the United States.`
        : `This specific item appears to have a United States shipping restriction. I can help you find similar pieces that may ship to ${escapeHtml(country)}.`;
    }

    if (restriction.type === "us_canada_only") {
      return country === "United States" || country === "Canada"
        ? `Yes. Based on this product’s shipping note, this item can ship to ${escapeHtml(country)}.`
        : `This specific item appears to have a United States and Canada shipping restriction. I can help you find similar pieces that may ship to ${escapeHtml(country)}.`;
    }

    if (group === "m_collection") {
      return M_COLLECTION_COUNTRIES.includes(country)
        ? `Yes. This M Collection item can generally ship to ${escapeHtml(country)}. I will still recommend reviewing checkout for final carrier confirmation.`
        : `This M Collection item is not currently available for shipping to ${escapeHtml(country)}. I can show you similar Michelle Francisco Beauty items with broader shipping availability.`;
    }

    if (group === "michelle_francisco") {
      return `This item generally supports broader shipping availability, but some products may have specific restrictions. Based on the current product details, I do not see a country restriction for ${escapeHtml(country)}. Please confirm at checkout for final carrier availability.`;
    }

    return `I need to check this item more carefully. Please review checkout for final shipping confirmation, or ask me to find similar items available for ${escapeHtml(country)}.`;
  }

  function getProductShippingSummary(product) {
  const restriction = detectDescriptionRestriction(product.description || "");
  const group = getPublicProductGroup(product);

  if (restriction.type === "us_only") {
    return `Shipping note: this item appears limited to United States shipping. Ask Star: “Can this ship to my country?”`;
  }

  if (restriction.type === "us_canada_only") {
    return `Shipping note: this item appears limited to United States and Canada shipping. Ask Star: “Can this ship to my country?”`;
  }

  if (group === "m_collection") {
    return `Shipping note: M Collection ships to 44 countries. Ask Star to check your country.`;
  }

  if (group === "michelle_francisco") {
    return `Shipping note: this item generally supports broader shipping availability, but Star can check product-specific restrictions.`;
  }

  return `Ask Star to check shipping availability for your country.`;
}

  function getPublicProductGroup(product) {
    const vendor = String(product.vendor || "").trim().toLowerCase();

    if (vendor === "m collection") return "m_collection";
    if (vendor === "michelle francisco") return "michelle_francisco";

    return "other";
  }

  function detectDescriptionRestriction(description) {
    const d = String(description || "").toLowerCase();

    const usOnly =
      /\b(us|u\.s\.|usa|u\.s\.a\.|united states)\s+only\b/i.test(d) ||
      /\bonly\s+(ships|available|delivers)\s+(in|to)\s+(the\s+)?(us|u\.s\.|usa|u\.s\.a\.|united states)\b/i.test(d) ||
      /\bships\s+only\s+(in|to)\s+(the\s+)?(us|u\.s\.|usa|u\.s\.a\.|united states)\b/i.test(d);

    const usCanadaOnly =
      /\b(us|u\.s\.|usa|u\.s\.a\.|united states)\s+(and|&)\s+canada\s+only\b/i.test(d) ||
      /\bcanada\s+(and|&)\s+(us|u\.s\.|usa|u\.s\.a\.|united states)\s+only\b/i.test(d) ||
      /\bonly\s+(ships|available|delivers)\s+(in|to)\s+(the\s+)?(us|u\.s\.|usa|u\.s\.a\.|united states)\s+(and|&)\s+canada\b/i.test(d);

    if (usCanadaOnly) return { type: "us_canada_only" };
    if (usOnly) return { type: "us_only" };

    return { type: "none" };
  }

  function isShippingQuery(q) {
    return (
      q.includes("ship") ||
      q.includes("shipping") ||
      q.includes("deliver") ||
      q.includes("delivery") ||
      q.includes("country") ||
      q.includes("available in") ||
      q.includes("can this go to") ||
      q.includes("can this ship to")
    );
  }

  function detectCountry(query) {
  const q = normalizeText(query);

  /*
    Check full country names first.
    This prevents "Australia" from being mistaken as "US"
    because the letters "us" appear inside "australia".
  */
  for (const country of M_COLLECTION_COUNTRIES) {
    const normalizedCountry = normalizeText(country);

    if (q === normalizedCountry || q.includes(normalizedCountry)) {
      return country;
    }
  }

  /*
    Check short aliases only as whole words.
    This prevents "us" from matching inside "australia".
  */
  const words = q.split(/\s+/).filter(Boolean);

  for (const alias in COUNTRY_ALIASES) {
    const normalizedAlias = normalizeText(alias);

    if (words.includes(normalizedAlias)) {
      return COUNTRY_ALIASES[alias];
    }
  }

  return null;
}

  function normalizeText(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s.]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function improveLabels() {
    const replacements = {
      "Add to cart": "Add to Bag",
      "Check out": "Checkout",
      "Continue shopping": "Continue Shopping",
      "Sold out": "Sold Out",
      "Jeans & Demin": "Jeans & Denim",
      "Lougeware & Intimates": "Loungewear & Intimates",
      "Cross Body Bags": "Crossbody Bags",
      "M Collection (US Shipping Only)": "M Collection"
    };

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(node => {
      let value = node.nodeValue;
      Object.keys(replacements).forEach(find => {
        if (value.includes(find)) value = value.replaceAll(find, replacements[find]);
      });
      node.nodeValue = value;
    });
  }

  function fixProductCardNoise() {
  return;
}

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
})();